import React, { useState, useEffect } from 'react';
import './App.css';
import axios from 'axios';
import { Button } from './components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './components/ui/card';
import { Input } from './components/ui/input';
import { Label } from './components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './components/ui/select';
import { Textarea } from './components/ui/textarea';
import { Badge } from './components/ui/badge';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './components/ui/tabs';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from './components/ui/dropdown-menu';
import { Calendar } from './components/ui/calendar';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from './components/ui/dialog';
import { toast } from 'sonner';
import { Toaster } from './components/ui/sonner';
import { CalendarDays, Clock, Users, TrendingUp, DollarSign, MapPin, Plus, CheckCircle, CheckCircle2, XCircle, AlertCircle, PiggyBank, Receipt, Trash2, Trophy, UserCheck, Edit, Download, Filter, FileText, Search, Phone, Mail, ChevronLeft, ChevronRight, LayoutGrid, List, Eye, MessageSquare, ChevronDown, Database, Image as ImageIcon, Landmark, RotateCcw, Star, History, ClipboardList, Package, Repeat, Gift, X } from 'lucide-react';

// Refactored Tab Components
import { LeagueTab, RefereesTab, FinancialsTab, CalendarTab, NotificationsTab, EventsTab, DatabaseTab, PersonnelTab, DashboardTab, BlogTab, ReportsTab, FeedbackTab, ActivityLogTab, TasksTab, DemirbasTab, RoutinesTab, LeavesTab, AttendancePanel } from './components/tabs';
import CustomersTab from './components/tabs/CustomersTab';
import BonusesTab from './components/tabs/BonusesTab';
import VatTab from './components/tabs/VatTab';
import CashAccountsTab from './components/tabs/CashAccountsTab';
import ClosingTab from './components/tabs/ClosingTab';
import RemindersTab from './components/tabs/RemindersTab';
import InvoiceFiles from './components/InvoiceFiles';
import OrganizationsTab from './components/tabs/OrganizationsTab';
import RefereePortal from './components/RefereePortal';
import FeedbackPage from './components/FeedbackPage';
import LandingPage from './components/LandingPage';
import PersonnelMesaiBanner from './components/PersonnelMesaiBanner';
import AdminShell from './components/AdminShell';
import PageHeader from './components/ui-pro/PageHeader';
import StatCard from './components/ui-pro/StatCard';
import ProTable from './components/ui-pro/ProTable';
import DashboardHome from './components/tabs/DashboardHome';
import { BlogListPage, BlogArticlePage } from './components/BlogPages';
import NewReservationDialog from './components/modals/NewReservationDialog';
import SalonHoursModal from './components/modals/SalonHoursModal';
import OccupancyTab from './components/tabs/OccupancyTab';
import EventDetailPage from './components/EventDetailPage';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// ===== KDV (Fatura) yardımcıları: faturalı işlemde girilen tutar KDV'siz matrahtır =====
const VAT_RATE = 20;
const KASA_EXCLUSION_START_LABEL = '09.10.2026';
const formatTL = (n) => `₺${(Number(n) || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const formatDateTR = (d) => (d ? String(d).slice(0, 10).split('-').reverse().join('.') : '-');
const vatPreview = (amount) => {
  const base = Number(amount) || 0;
  const vat = Math.round(base * VAT_RATE) / 100;
  return { base, vat, total: base + vat };
};
// Süre artık başlangıç/bitiş saatinden otomatik hesaplanır (süre seçici kaldırıldı)
const calcDurationHours = (start, end) => {
  if (!start || !end) return 1;
  const [sh, sm] = String(start).split(':').map(Number);
  const [eh, em] = String(end).split(':').map(Number);
  let mins = (eh * 60 + em) - (sh * 60 + sm);
  if (mins <= 0) mins += 24 * 60;
  return Math.round((mins / 60) * 100) / 100;
};


// JWT'nin süresi dolmuş mu? (yalnızca client-side ön kontrol; asıl doğrulama backend'de)
const isTokenExpired = (token) => {
  if (!token) return true;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    if (!payload.exp) return false;
    return payload.exp * 1000 < Date.now();
  } catch {
    return true;
  }
};

function App() {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [financialsSubTab, setFinancialsSubTab] = useState('ledger');
  const [showNewReservationDialog, setShowNewReservationDialog] = useState(false);
  const [financialsQuickAction, setFinancialsQuickAction] = useState(null);
  const [orgAutoOpenNew, setOrgAutoOpenNew] = useState(false);
  const [calendarOrganizations, setCalendarOrganizations] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(() => {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
  });
  const [archiveMonths, setArchiveMonths] = useState([]);
  const [salons, setSalons] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [reservations, setReservations] = useState([]);
  const [todayReservations, setTodayReservations] = useState([]);
  const [dailyRevenue, setDailyRevenue] = useState(null);
  const [monthlyRevenue, setMonthlyRevenue] = useState(null);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [customerReservations, setCustomerReservations] = useState([]);
  const [showCustomerModal, setShowCustomerModal] = useState(false);
  const [incomes, setIncomes] = useState([]);
  const [expenses, setExpenses] = useState([]);
  const [financialSummary, setFinancialSummary] = useState(null);
  const [categories, setCategories] = useState([]);
  const [teams, setTeams] = useState([]);
  const [matches, setMatches] = useState([]);
  const [referees, setReferees] = useState([]);
  const [refereeAssignments, setRefereeAssignments] = useState([]);
  const [refereesTotalBalance, setRefereesTotalBalance] = useState(null);
  const [focusCustomerId, setFocusCustomerId] = useState(null);
  const [focusRefereeId, setFocusRefereeId] = useState(null);
  const [currentUser, setCurrentUser] = useState(null);
  const [showLogin, setShowLogin] = useState(true);
  const [showLoginModal, setShowLoginModal] = useState(typeof window !== 'undefined' && window.location.pathname.startsWith('/admin'));
  const [loginForm, setLoginForm] = useState({
    username: '',
    password: ''
  });
  const [refereeData, setRefereeData] = useState(null);
  const [events, setEvents] = useState([]);
  
  // Personel State'leri
  const [personnelList, setPersonnelList] = useState([]);
  const [showAddPersonnelModal, setShowAddPersonnelModal] = useState(false);
  const [newPersonnel, setNewPersonnel] = useState({
    name: '',
    phone: '',
    email: '',
    position: '',
    username: '',
    password: '',
    salary: 0,
    permissions: []
  });
  const [editingPersonnel, setEditingPersonnel] = useState(null);
  const [showEditPersonnelModal, setShowEditPersonnelModal] = useState(false);
  
  // Yetki ve Admin Ayarları State'leri
  const [showPermissionsModal, setShowPermissionsModal] = useState(false);
  const [selectedPersonnelForPermissions, setSelectedPersonnelForPermissions] = useState(null);
  const [showAdminSettingsModal, setShowAdminSettingsModal] = useState(false);
  const [adminSettings, setAdminSettings] = useState({
    username: 'admin',
    current_password: '',
    new_password: '',
    new_password_confirm: ''
  });
  
  // Tüm izin seçenekleri
  const ALL_PERMISSIONS = [
    { id: 'dashboard', label: 'Dashboard', icon: '📊' },
    { id: 'takvim', label: 'Takvim', icon: '📅' },
    { id: 'rezervasyonlar', label: 'Rezervasyonlar', icon: '📋' },
    { id: 'musteriler', label: 'Müşteriler', icon: '👥' },
    { id: 'salonlar', label: 'Salonlar', icon: '🏢' },
    { id: 'kasa', label: 'Kasa', icon: '💰' },
    { id: 'kasa_hesap', label: 'Kasalar: Hesap Ekleme/Silme', icon: '🏦' },
    { id: 'gunsonu', label: 'Gün Sonu Kontrol / Kapanış', icon: '🧮' },
    { id: 'hakemler', label: 'Hakemler', icon: '⚽' },
    { id: 'personel', label: 'Personel', icon: '👤' },
    { id: 'analiz', label: 'Analiz', icon: '📈' },
    { id: 'gorevler', label: 'Görevler', icon: '📋' },
    { id: 'rutinler', label: 'Rutinler', icon: '🔁' },
    { id: 'mesai', label: 'Mesai (PDKS)', icon: '⏱️' },
    { id: 'org_view', label: 'Organizasyonlar: Görüntüleme', icon: '📅' },
    { id: 'org_create', label: 'Organizasyon: Oluşturma', icon: '➕' },
    { id: 'org_edit', label: 'Organizasyon: Düzenleme', icon: '✏️' },
    { id: 'org_income', label: 'Organizasyon: Gelir Ekleme', icon: '💰' },
    { id: 'org_expense', label: 'Organizasyon: Gider Ekleme', icon: '💸' },
    { id: 'org_finance_edit', label: 'Organizasyon: Finansal Düzeltme/İade', icon: '🧾' },
    { id: 'org_complete', label: 'Organizasyon: Tamamlama', icon: '✅' },
    { id: 'org_cancel', label: 'Organizasyon: İptal', icon: '🚫' },
    { id: 'org_report', label: 'Organizasyon: Rapor İndirme', icon: '📄' }
  ];

  // Personel, yetkisi olmayan bir sayfada kalmasın → ilk yetkili sekmeye yönlendirilir
  const PERM_TAB_ORDER = [
    ['dashboard', 'dashboard'], ['takvim', 'calendar'], ['rezervasyonlar', 'reservations'],
    ['musteriler', 'customers'], ['salonlar', 'salons'], ['kasa', 'financials'],
    ['kasa_hesap', 'cash-accounts'], ['gunsonu', 'closing'], ['hakemler', 'referees'],
    ['analiz', 'analytics'], ['org_view', 'organizations'], ['personel', 'staff'],
    ['mesai', 'mesai'], ['gorevler', 'tasks-overview'], ['rutinler', 'routines'],
    ['demirbas', 'demirbas'], ['bildirimler', 'notifications'], ['geribildirim', 'feedback'],
    ['islemkayitlari', 'activity-log'],
  ];
  useEffect(() => {
    if (currentUser?.role !== 'personel') return;
    const perms = currentUser.permissions || [];
    const allowed = PERM_TAB_ORDER.filter(([p]) => perms.includes(p)).map(([, t]) => t);
    allowed.push('reminders'); // hatırlatmalar her personele açık (yalnızca kendi kayıtları)
    allowed.push('dashboard'); // ana sayfa herkese açık (finansal veriler yetkiye göre gizlenir)
    if (allowed.length && !allowed.includes(activeTab)) setActiveTab(allowed[0]);
  }, [currentUser, activeTab]); // eslint-disable-line

  
  // Hakem Credential State'leri
  const [showRefereeCredentialModal, setShowRefereeCredentialModal] = useState(false);
  const [selectedRefereeForCredentials, setSelectedRefereeForCredentials] = useState(null);
  const [refereeCredentials, setRefereeCredentials] = useState({ username: '', password: '' });
  
  // Form states
  const [selectedDate, setSelectedDate] = useState(new Date());
  
  // Takvim State'leri
  const [calendarView, setCalendarView] = useState('week'); // 'day', 'week', 'month'
  const [calendarFilters, setCalendarFilters] = useState({
    salon_id: 'all',
    referee_id: 'all'
  });
  const [showQuickReservationModal, setShowQuickReservationModal] = useState(false);
  const [quickReservationData, setQuickReservationData] = useState({
    date: '',
    start_time: '',
    salon_id: ''
  });
  const [newSalon, setNewSalon] = useState({
    name: '',
    sports: [],
    hourly_rate_1h: '',
    hourly_rate_1_5h: '',
    hourly_rate_2h: '',
    location: '',
    capacity: '',
    phone: '',
    description: ''
  });
  const [salonFilters, setSalonFilters] = useState({
    search: ''
  });
  const [newCustomer, setNewCustomer] = useState({
    name: '',
    phone: '',
    email: ''
  });
  const [editingCustomer, setEditingCustomer] = useState(null);
  const [showEditCustomerModal, setShowEditCustomerModal] = useState(false);
  
  // Düzenleme Modal State'leri
  const [editingReservation, setEditingReservation] = useState(null);
  const [showEditReservationModal, setShowEditReservationModal] = useState(false);
  const [editingSalon, setEditingSalon] = useState(null);
  const [showEditSalonModal, setShowEditSalonModal] = useState(false);
  const [showSalonHoursModal, setShowSalonHoursModal] = useState(false);
  const [salonHoursTarget, setSalonHoursTarget] = useState(null);
  const [editingIncome, setEditingIncome] = useState(null);
  const [showEditIncomeModal, setShowEditIncomeModal] = useState(false);
  const [editingExpense, setEditingExpense] = useState(null);
  const [showEditExpenseModal, setShowEditExpenseModal] = useState(false);
  const [editingReferee, setEditingReferee] = useState(null);
  const [showEditRefereeModal, setShowEditRefereeModal] = useState(false);
  const [editingTeam, setEditingTeam] = useState(null);
  const [showEditTeamModal, setShowEditTeamModal] = useState(false);
  const [editingMatch, setEditingMatch] = useState(null);
  const [showEditMatchModal, setShowEditMatchModal] = useState(false);
  
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [showTeamDetailModal, setShowTeamDetailModal] = useState(false);
  const [teamMatches, setTeamMatches] = useState([]);
  const [selectedMatch, setSelectedMatch] = useState(null);
  const [showMatchDetailModal, setShowMatchDetailModal] = useState(false);
  const [matchFilters, setMatchFilters] = useState({
    week: 'all',
    status: 'all',
    team: 'all'
  });
  const [selectedReferee, setSelectedReferee] = useState(null);
  const [showRefereeDetailModal, setShowRefereeDetailModal] = useState(false);
  const [refereeFinancial, setRefereeFinancial] = useState(null);
  const [refereePayments, setRefereePayments] = useState([]);
  const [newRefereePayment, setNewRefereePayment] = useState({
    amount: '',
    payment_type: 'tahsilat',
    date: new Date().toISOString().split('T')[0],
    notes: ''
  });
  
  // Personel detay state'leri
  const [selectedPersonnel, setSelectedPersonnel] = useState(null);
  const [showPersonnelDetailModal, setShowPersonnelDetailModal] = useState(false);
  const [personnelPayments, setPersonnelPayments] = useState([]);
  const [personnelSummary, setPersonnelSummary] = useState(null);
  const [newPersonnelPayment, setNewPersonnelPayment] = useState({
    amount: '',
    payment_type: 'maas',
    date: new Date().toISOString().split('T')[0],
    month: new Date().toISOString().slice(0, 7),
    notes: ''
  });
  
  // Hakem ekstra gider state'leri
  const [showRefereeExpenseModal, setShowRefereeExpenseModal] = useState(false);
  const [selectedExpenseReservation, setSelectedExpenseReservation] = useState(null);
  const [refereeExpense, setRefereeExpense] = useState({
    amount: '',
    notes: ''
  });
  
  // Rezervasyon detay state'leri
  const [showReservationDetailModal, setShowReservationDetailModal] = useState(false);
  const [selectedReservationDetail, setSelectedReservationDetail] = useState(null);
  // Havale (bankaya çek) modalı
  const [showResTransferModal, setShowResTransferModal] = useState(false);
  const [resTransferMethod, setResTransferMethod] = useState('garanti_bbva');
  const [resTransferLoading, setResTransferLoading] = useState(false);
  // Hakemsiz rezervasyon "Ödendi" işaretlenince hesap (kasa) seçim modalı
  const [showPayMethodModal, setShowPayMethodModal] = useState(false);
  const [payMethodTarget, setPayMethodTarget] = useState(null);
  const [payMethodChoice, setPayMethodChoice] = useState('nakit');
  const [payMethodLoading, setPayMethodLoading] = useState(false);
  const [reservationExpenses, setReservationExpenses] = useState([]);
  const [allReservationExpenses, setAllReservationExpenses] = useState([]); // Tüm rezervasyon giderleri
  const [newReservationExpense, setNewReservationExpense] = useState({
    amount: '',
    description: '',
    kind: 'normal',
    source_reservation_id: ''
  });
  const [newReservation, setNewReservation] = useState({
    salon_id: '',
    customer_id: '',
    date: new Date().toISOString().split('T')[0],
    start_time: '',
    end_time: '',
    duration_hours: 1,
    payment_method: 'nakit',
    paid_amount: '',
    total_amount: '',
    referee_id: '',
    referee_fee: '',
    invoice_issued: false,
    notes: ''
  });
  
  // Rezervasyon Filtreleri
  const [reservationFilters, setReservationFilters] = useState({
    salon_id: 'all',
    referee_id: 'all',
    payment_status: 'all',
    invoice_status: 'all',
    date_from: '',
    date_to: ''
  });
  
  // Rezervasyon Aylık Filtreleme
  const [reservationMonth, setReservationMonth] = useState(new Date().getMonth());
  const [reservationYear, setReservationYear] = useState(new Date().getFullYear());
  
  // Müşteri Filtreleri
  const [customerFilters, setCustomerFilters] = useState({
    search: '',
    balance_status: 'all'
  });
  
  // Rezervasyon müşteri arama
  const [customerSearchQuery, setCustomerSearchQuery] = useState('');
  
  // Analiz Filtreleri
  const [analyticsFilters, setAnalyticsFilters] = useState({
    period: 'month', // day, week, month, year, custom
    date_from: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().split('T')[0],
    date_to: new Date().toISOString().split('T')[0]
  });
  
  // Personel Filtreleri
  const [personnelFilters, setPersonnelFilters] = useState({
    search: '',
    level: 'all',
    balance_status: 'all'
  });
  const [newIncome, setNewIncome] = useState({
    title: '',
    amount: '',
    category: 'diger',
    date: new Date().toISOString().split('T')[0],
    notes: ''
  });
  const [newExpense, setNewExpense] = useState({
    title: '',
    amount: '',
    category: 'diger',
    date: new Date().toISOString().split('T')[0],
    notes: ''
  });
  const [newTeam, setNewTeam] = useState({
    name: '',
    captain: '',
    phone: '',
    logo_url: '',
    registration_fee: '',
    match_fee_per_game: ''
  });
  const [newMatch, setNewMatch] = useState({
    home_team_id: '',
    away_team_id: '',
    date: new Date().toISOString().split('T')[0],
    time: '19:00',
    week: 1,
    match_type: 'lig_maci',
    salon_id: '',
    referee_id: '',
    referee_fee: '',
    home_team_payment_amount: '',
    away_team_payment_amount: '',
    field_rent: '',
    other_expenses: '',
    notes: ''
  });
  
  // Lig State'leri
  const [leagueStats, setLeagueStats] = useState(null);
  const [matchPersonnel, setMatchPersonnel] = useState([]);
  const [showAddMatchModal, setShowAddMatchModal] = useState(false);
  const [leagueTab, setLeagueTab] = useState('matches'); // 'matches', 'teams'
  
  // Personel Görevleri State'leri
  const [showPersonnelAssignmentsModal, setShowPersonnelAssignmentsModal] = useState(false);
  const [selectedPersonnelAssignments, setSelectedPersonnelAssignments] = useState(null);
  
  const MATCH_PERSONNEL_ROLES = [
    { id: 'saha_gorevlisi', label: 'Saha Görevlisi' },
    { id: 'guvenlik', label: 'Güvenlik' },
    { id: 'koordinator', label: 'Koordinatör' },
    { id: 'kameraman', label: 'Kameraman' },
    { id: 'diger', label: 'Diğer' }
  ];
  
  const MATCH_STATUS_OPTIONS = [
    { id: 'planlanmis', label: 'Planlandı', color: 'blue' },
    { id: 'devam_ediyor', label: 'Oynanıyor', color: 'yellow' },
    { id: 'tamamlandi', label: 'Tamamlandı', color: 'green' },
    { id: 'iptal', label: 'İptal', color: 'red' }
  ];
  
  const [newReferee, setNewReferee] = useState({
    name: '',
    phone: '',
    level: 'junior',
    fee_per_match: ''
  });
  const [newCategory, setNewCategory] = useState({
    name: '',
    type: 'income'
  });

  // İlk veri yüklemesi sürerken "kayıt yok" yerine "yükleniyor" göstermek için
  const [initialLoading, setInitialLoading] = useState(true);

  // Fetch data functions
  const fetchSalons = async () => {
    try {
      const response = await axios.get(`${API}/salons`);
      setSalons(response.data);
    } catch (error) {
      console.error('Salon verisi alınamadı:', error);
      toast.error('Salon verisi alınamadı');
    }
  };

  const fetchCustomers = async () => {
    try {
      const response = await axios.get(`${API}/customers`);
      setCustomers(response.data);
    } catch (error) {
      console.error('Müşteri verisi alınamadı:', error);
      toast.error('Müşteri verisi alınamadı');
    }
  };

  const fetchReservations = async (month) => {
    try {
      const m = month || selectedMonth;
      const response = await axios.get(`${API}/reservations`, { params: { month: m } });
      setReservations(response.data);
    } catch (error) {
      console.error('Rezervasyon verisi alınamadı:', error);
      toast.error('Rezervasyon verisi alınamadı');
    }
  };

  // Rezervasyonlar sekmesinde görüntülenen ayı yeniden çek (global selectedMonth yerine sekme ayı)
  const refreshReservationTab = () => {
    const monthStr = `${reservationYear}-${String(reservationMonth + 1).padStart(2, '0')}`;
    return fetchReservations(monthStr);
  };

  const fetchTodayReservations = async () => {
    try {
      const response = await axios.get(`${API}/reservations/today`);
      setTodayReservations(response.data);
    } catch (error) {
      console.error('Bugünkü rezervasyonlar alınamadı:', error);
    }
  };

  const fetchAnalytics = async () => {
    try {
      const [dailyRes, monthlyRes, financialRes] = await Promise.all([
        axios.get(`${API}/analytics/daily-revenue`),
        axios.get(`${API}/analytics/monthly-revenue`),
        axios.get(`${API}/analytics/financial-summary`)
      ]);
      setDailyRevenue(dailyRes.data);
      setMonthlyRevenue(monthlyRes.data);
      setFinancialSummary(financialRes.data);
    } catch (error) {
      console.error('Analiz verisi alınamadı:', error);
    }
  };

  const fetchIncomes = async (month) => {
    try {
      const m = month || selectedMonth;
      const response = await axios.get(`${API}/incomes`, { params: { month: m } });
      setIncomes(response.data);
    } catch (error) {
      console.error('Gelir verisi alınamadı:', error);
      toast.error('Gelir verisi alınamadı');
    }
  };

  const fetchExpenses = async (month) => {
    try {
      const m = month || selectedMonth;
      const response = await axios.get(`${API}/expenses`, { params: { month: m } });
      setExpenses(response.data);
    } catch (error) {
      console.error('Gider verisi alınamadı:', error);
      toast.error('Gider verisi alınamadı');
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await axios.get(`${API}/categories`);
      setCategories(response.data);
    } catch (error) {
      console.error('Kategori verisi alınamadı:', error);
    }
  };

  const fetchArchiveMonths = async () => {
    try {
      const response = await axios.get(`${API}/archive/months`);
      setArchiveMonths(response.data);
    } catch (error) {
      console.error('Arşiv ayları alınamadı:', error);
    }
  };

  const handleMonthChange = (month) => {
    setSelectedMonth(month);
    fetchIncomes(month);
    fetchExpenses(month);
    fetchReservations(month);
  };
  
  const fetchAllReservationExpenses = async () => {
    try {
      const response = await axios.get(`${API}/reservation-expenses`);
      setAllReservationExpenses(response.data);
    } catch (error) {
      console.error('Rezervasyon giderleri alınamadı:', error);
    }
  };

  const fetchTeams = async () => {
    try {
      const response = await axios.get(`${API}/teams`);
      setTeams(response.data);
    } catch (error) {
      console.error('Takım verisi alınamadı:', error);
      toast.error('Takım verisi alınamadı');
    }
  };

  const fetchMatches = async () => {
    try {
      const response = await axios.get(`${API}/matches`);
      setMatches(response.data);
    } catch (error) {
      console.error('Maç verisi alınamadı:', error);
      toast.error('Maç verisi alınamadı');
    }
  };

  const fetchLeagueStats = async () => {
    try {
      const response = await axios.get(`${API}/league/statistics`);
      setLeagueStats(response.data);
    } catch (error) {
      console.error('Lig istatistikleri alınamadı:', error);
    }
  };

  const fetchMatchDetail = async (matchId) => {
    try {
      const response = await axios.get(`${API}/matches/${matchId}`);
      setSelectedMatch(response.data);
      setMatchPersonnel(response.data.personnel || []);
    } catch (error) {
      toast.error('Maç detayları alınamadı');
    }
  };

  const addPersonnelToMatch = async (matchId, personnelId, role) => {
    try {
      await axios.post(`${API}/match-personnel`, {
        match_id: matchId,
        personnel_id: personnelId,
        role: role
      });
      toast.success('Personel maça eklendi');
      fetchMatchDetail(matchId);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Personel eklenemedi');
    }
  };

  const updatePersonnelAttendance = async (assignmentId, attended, matchId) => {
    try {
      await axios.put(`${API}/match-personnel/${assignmentId}/attendance?attended=${attended}`);
      toast.success(attended ? 'Geldi olarak işaretlendi' : 'Gelmedi olarak işaretlendi');
      fetchMatchDetail(matchId);
    } catch (error) {
      toast.error('Güncellenemedi');
    }
  };

  const removePersonnelFromMatch = async (assignmentId, matchId) => {
    if (!window.confirm('Bu personeli maçtan çıkarmak istediğinize emin misiniz?')) return;
    try {
      await axios.delete(`${API}/match-personnel/${assignmentId}`);
      toast.success('Personel maçtan çıkarıldı');
      fetchMatchDetail(matchId);
    } catch (error) {
      toast.error('Silinemedi');
    }
  };

  const updateMatchStatus = async (matchId, status) => {
    try {
      await axios.put(`${API}/matches/${matchId}`, { status });
      toast.success('Maç durumu güncellendi');
      fetchMatches();
      fetchLeagueStats();
      if (selectedMatch?.id === matchId) {
        fetchMatchDetail(matchId);
      }
    } catch (error) {
      toast.error('Güncellenemedi');
    }
  };

  const updateMatchPayment = async (matchId, teamType, paymentData) => {
    try {
      await axios.put(`${API}/matches/${matchId}/payment`, {
        team_type: teamType,
        ...paymentData
      });
      toast.success('Ödeme kaydedildi');
      fetchMatches();
      fetchLeagueStats();
      fetchIncomes();
      if (selectedMatch?.id === matchId) {
        fetchMatchDetail(matchId);
      }
    } catch (error) {
      toast.error('Ödeme kaydedilemedi');
    }
  };

  const fetchReferees = async () => {
    try {
      const response = await axios.get(`${API}/referees`);
      setReferees(response.data);
    } catch (error) {
      console.error('Hakem verisi alınamadı:', error);
      toast.error('Hakem verisi alınamadı');
    }
  };

  const fetchRefereesTotalBalance = async () => {
    try {
      const response = await axios.get(`${API}/referees/total-balance`);
      setRefereesTotalBalance(response.data);
    } catch (error) {
      console.error('Hakem bakiye verisi alınamadı:', error);
    }
  };

  // Personel API fonksiyonları
  const fetchPersonnel = async () => {
    try {
      const response = await axios.get(`${API}/personnel`);
      setPersonnelList(response.data);
    } catch (error) {
      console.error('Personel verisi alınamadı:', error);
    }
  };

  const fetchEvents = async () => {
    try {
      const response = await axios.get(`${API}/events/all`);
      setEvents(response.data);
    } catch (error) {
      console.error('Etkinlikler alınamadı:', error);
    }
  };


  const handleAddPersonnel = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API}/personnel`, newPersonnel);
      toast.success('Personel eklendi');
      fetchPersonnel();
      setShowAddPersonnelModal(false);
      setNewPersonnel({ name: '', phone: '', email: '', position: '', username: '', password: '', salary: 0, permissions: [] });
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Personel eklenemedi');
    }
  };

  const handleUpdatePersonnel = async (e) => {
    e.preventDefault();
    try {
      const updateData = { ...editingPersonnel };
      if (!updateData.password) delete updateData.password;
      await axios.put(`${API}/personnel/${editingPersonnel.id}`, updateData);
      toast.success('Personel güncellendi');
      fetchPersonnel();
      setShowEditPersonnelModal(false);
      setEditingPersonnel(null);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Personel güncellenemedi');
    }
  };

  const handleDeletePersonnel = async (personnelId) => {
    if (!window.confirm('Bu personeli silmek istediğinize emin misiniz?')) return;
    try {
      await axios.delete(`${API}/personnel/${personnelId}`);
      toast.success('Personel silindi');
      fetchPersonnel();
    } catch (error) {
      toast.error('Personel silinemedi');
    }
  };

  // Yetki yönetimi fonksiyonları
  const openPermissionsModal = (person) => {
    setSelectedPersonnelForPermissions(person);
    setShowPermissionsModal(true);
  };

  const handleUpdatePermissions = async (newPermissions) => {
    if (!selectedPersonnelForPermissions) return;
    try {
      await axios.put(`${API}/personnel/${selectedPersonnelForPermissions.id}/permissions`, newPermissions);
      toast.success('Yetkiler güncellendi');
      fetchPersonnel();
      setShowPermissionsModal(false);
    } catch (error) {
      toast.error('Yetkiler güncellenemedi');
    }
  };

  // Personel Görevleri fonksiyonu
  const openPersonnelAssignmentsModal = async (person) => {
    try {
      const response = await axios.get(`${API}/personnel/${person.id}/match-assignments`);
      setSelectedPersonnelAssignments(response.data);
      setShowPersonnelAssignmentsModal(true);
    } catch (error) {
      toast.error('Görevler yüklenemedi');
    }
  };

  const updateAssignmentAttendance = async (assignmentId, attended) => {
    try {
      await axios.put(`${API}/match-personnel/${assignmentId}/attendance?attended=${attended}`);
      toast.success(attended ? 'Geldi olarak işaretlendi' : 'Gelmedi olarak işaretlendi');
      // Modal'ı güncelle
      if (selectedPersonnelAssignments) {
        const response = await axios.get(`${API}/personnel/${selectedPersonnelAssignments.personnel_id}/match-assignments`);
        setSelectedPersonnelAssignments(response.data);
      }
    } catch (error) {
      toast.error('Güncellenemedi');
    }
  };

  // Admin ayarları fonksiyonları
  const openAdminSettingsModal = async () => {
    try {
      const response = await axios.get(`${API}/admin/settings`);
      setAdminSettings({
        username: response.data.username || 'admin',
        current_password: '',
        new_password: '',
        new_password_confirm: ''
      });
    } catch (error) {
      setAdminSettings({
        username: 'admin',
        current_password: '',
        new_password: '',
        new_password_confirm: ''
      });
    }
    setShowAdminSettingsModal(true);
  };

  const handleUpdateAdminSettings = async (e) => {
    e.preventDefault();
    if (adminSettings.new_password && adminSettings.new_password !== adminSettings.new_password_confirm) {
      toast.error('Yeni şifreler eşleşmiyor');
      return;
    }
    try {
      await axios.put(`${API}/admin/settings`, {
        username: adminSettings.username,
        current_password: adminSettings.current_password,
        new_password: adminSettings.new_password || null
      });
      toast.success('Admin ayarları güncellendi. Yeni bilgilerinizle tekrar giriş yapmanız gerekebilir.');
      setShowAdminSettingsModal(false);
      // Şifre değiştiyse çıkış yaptır
      if (adminSettings.new_password) {
        setTimeout(() => {
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          window.location.reload();
        }, 2000);
      }
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Ayarlar güncellenemedi');
    }
  };

  // Hakem Credential fonksiyonları
  const handleOpenRefereeCredentialModal = async (referee) => {
    setSelectedRefereeForCredentials(referee);
    try {
      const response = await axios.get(`${API}/referees/${referee.id}/credentials`);
      setRefereeCredentials({
        username: response.data.username || '',
        password: ''
      });
    } catch (error) {
      setRefereeCredentials({ username: '', password: '' });
    }
    setShowRefereeCredentialModal(true);
  };

  const handleUpdateRefereeCredentials = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`${API}/referees/${selectedRefereeForCredentials.id}/credentials`, refereeCredentials);
      toast.success('Hakem giriş bilgileri güncellendi');
      setShowRefereeCredentialModal(false);
      setSelectedRefereeForCredentials(null);
      setRefereeCredentials({ username: '', password: '' });
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Giriş bilgileri güncellenemedi');
    }
  };

  // Takvimde organizasyon oturumlarını adıyla göstermek için hafif liste
  useEffect(() => {
    axios.get(`${API}/organizations`, { params: { limit: 500 } })
      .then(r => setCalendarOrganizations((r.data?.items || r.data || []).map(o => ({ id: o.id, name: o.name }))))
      .catch(() => setCalendarOrganizations([]));
  }, []);

  useEffect(() => {
    // Ana ekranı dolduran kritik veriler paralel çekilir; tamamlanınca iskelet/yükleniyor durumu kalkar.
    Promise.all([
      fetchSalons(),
      fetchCustomers(),
      fetchReservations(),
      fetchTodayReservations(),
      fetchIncomes(),
      fetchExpenses(),
      fetchReferees(),
      fetchRefereesTotalBalance(),
    ]).finally(() => setInitialLoading(false));
    // İkincil veriler ekranı bloklamaz
    fetchAnalytics();
    fetchCategories();
    fetchTeams();
    fetchMatches();
    fetchPersonnel();
    fetchAllReservationExpenses();
    fetchArchiveMonths();
  }, []);

  // Sekme değişiminde rezervasyon verisini doğru bağlama göre yükle.
  // Rezervasyonlar sekmesi kendi ay seçicisini kullanır (geçmiş aylara erişim için),
  // Hakemler sekmesi tüm ayların bakiyesini hesapladığı için TÜM rezervasyonları yükler,
  // diğer sekmeler global seçili ayı kullanır.
  useEffect(() => {
    if (activeTab === 'reservations') {
      const monthStr = `${reservationYear}-${String(reservationMonth + 1).padStart(2, '0')}`;
      fetchReservations(monthStr);
    } else if (activeTab === 'referees' || activeTab === 'customers') {
      // Hakem ve Müşteri sayfaları tüm ayların cari/bakiye hesabını gösterir
      fetchReservations('all');
    } else if (activeTab === 'reports' || activeTab === 'analytics') {
      // Raporlar sekmesi serbest tarih aralığı (Bu Ay / Geçen Ay / Bu Yıl / özel) sorgular
      // → geçmiş dönemleri de kapsamak için TÜM veriyi yükle
      fetchReservations('all');
      fetchIncomes('all');
      fetchExpenses('all');
    } else if (activeTab === 'financials' || activeTab === 'calendar') {
      // Kasa & Takvim kendi ay/hafta seçicilerini yönetir; başlangıçta güncel ayı yükle
      fetchReservations(selectedMonth);
      fetchIncomes(selectedMonth);
      fetchExpenses(selectedMonth);
    } else {
      fetchReservations(selectedMonth);
      fetchIncomes(selectedMonth);
      fetchExpenses(selectedMonth);
    }
  }, [activeTab]);


  // Filtrelenmiş salonlar
  const getFilteredSalons = () => {
    return salons.filter(salon => {
      if (salonFilters.search) {
        const searchLower = salonFilters.search.toLowerCase();
        const nameMatch = salon.name?.toLowerCase().includes(searchLower);
        const locationMatch = salon.location?.toLowerCase().includes(searchLower);
        if (!nameMatch && !locationMatch) return false;
      }
      return true;
    });
  };

  // Salon istatistikleri
  const getSalonStats = () => {
    const filtered = getFilteredSalons();
    const totalCapacity = filtered.reduce((sum, s) => sum + (s.capacity || 0), 0);
    const avgRate = filtered.length > 0 
      ? filtered.reduce((sum, s) => sum + (s.hourly_rate_1h || 0), 0) / filtered.length 
      : 0;
    
    // Salon bazlı rezervasyon sayısı
    const reservationCounts = {};
    reservations.forEach(r => {
      reservationCounts[r.salon_id] = (reservationCounts[r.salon_id] || 0) + 1;
    });
    const totalReservations = filtered.reduce((sum, s) => sum + (reservationCounts[s.id] || 0), 0);
    
    return {
      total: filtered.length,
      totalCapacity,
      avgRate: avgRate.toFixed(0),
      totalReservations
    };
  };

  // Create functions
  const createSalon = async (e) => {
    e.preventDefault();
    try {
      const salonData = {
        ...newSalon,
        sports: newSalon.sports.length > 0 ? newSalon.sports : ['voleybol', 'basketbol'],
        hourly_rate_1h: parseFloat(newSalon.hourly_rate_1h),
        hourly_rate_1_5h: parseFloat(newSalon.hourly_rate_1_5h),
        hourly_rate_2h: parseFloat(newSalon.hourly_rate_2h),
        capacity: newSalon.capacity ? parseInt(newSalon.capacity) : null
      };
      
      await axios.post(`${API}/salons`, salonData);
      toast.success('Salon başarıyla eklendi');
      setNewSalon({
        name: '',
        sports: [],
        hourly_rate_1h: '',
        hourly_rate_1_5h: '',
        hourly_rate_2h: '',
        location: '',
        capacity: '',
        phone: '',
        description: ''
      });
      fetchSalons();
    } catch (error) {
      console.error('Salon eklenemedi:', error);
      toast.error('Salon eklenemedi');
    }
  };

  const createCustomer = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API}/customers`, newCustomer);
      toast.success('Müşteri başarıyla eklendi');
      setNewCustomer({ name: '', phone: '', email: '' });
      fetchCustomers();
    } catch (error) {
      console.error('Müşteri eklenemedi:', error);
      toast.error('Müşteri eklenemedi');
    }
  };

  const openEditCustomerModal = (customer) => {
    setEditingCustomer({
      id: customer.id,
      name: customer.name,
      phone: customer.phone || '',
      email: customer.email || ''
    });
    setShowEditCustomerModal(true);
  };

  const updateCustomer = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`${API}/customers/${editingCustomer.id}`, {
        name: editingCustomer.name,
        phone: editingCustomer.phone,
        email: editingCustomer.email
      });
      toast.success('Müşteri bilgileri güncellendi');
      setShowEditCustomerModal(false);
      setEditingCustomer(null);
      fetchCustomers();
    } catch (error) {
      console.error('Müşteri güncellenemedi:', error);
      toast.error('Müşteri güncellenemedi');
    }
  };

  // ==================== REZERVASYON DETAY FONKSİYONLARI ====================
  
  const openReservationDetail = async (reservation) => {
    // Müşteri ve salon bilgilerini ekle
    const customer = customers.find(c => c.id === reservation.customer_id);
    const salon = salons.find(s => s.id === reservation.salon_id);
    const referee = referees.find(r => r.id === reservation.referee_id);
    
    const enrichedReservation = {
      ...reservation,
      customer_name: customer?.name || 'Bilinmiyor',
      customer_phone: customer?.phone || '-',
      salon_name: salon?.name || 'Bilinmiyor',
      referee_name: referee?.name || null
    };
    
    setSelectedReservationDetail(enrichedReservation);
    
    // Rezervasyona ait giderleri getir
    try {
      const response = await axios.get(`${API}/reservation-expenses/${reservation.id}`);
      setReservationExpenses(response.data || []);
    } catch (error) {
      setReservationExpenses([]);
    }
    
    setShowReservationDetailModal(true);
  };
  
  // Rezervasyonu havale ile bankaya çek (hakem profiline düşürmeden)
  const confirmReservationTransfer = async () => {
    if (!selectedReservationDetail) return;
    setResTransferLoading(true);
    try {
      await axios.put(`${API}/reservations/${selectedReservationDetail.id}/bank-transfer`, {
        transfer: true,
        payment_method: resTransferMethod
      });
      toast.success(`Havale bankaya işlendi: ₺${(selectedReservationDetail.total_amount || 0).toLocaleString()}`);
      setShowResTransferModal(false);
      setShowReservationDetailModal(false);
      await Promise.all([fetchReservations(), fetchIncomes(), fetchExpenses(), fetchRefereesTotalBalance?.()]);
    } catch (error) {
      console.error(error);
      toast.error('Havale işlemi başarısız');
    } finally {
      setResTransferLoading(false);
    }
  };
  
  // Havaleyi geri al
  const undoReservationTransfer = async () => {
    if (!selectedReservationDetail) return;
    if (!window.confirm('Havale işlemini geri almak istiyor musunuz?\n\nBankaya yazılan gelir ve hakem ücreti gideri silinecek; rezervasyon yeniden hakemin bekleyen listesine düşecek.')) return;
    setResTransferLoading(true);
    try {
      await axios.put(`${API}/reservations/${selectedReservationDetail.id}/bank-transfer`, { transfer: false });
      toast.success('Havale geri alındı');
      setShowReservationDetailModal(false);
      await Promise.all([fetchReservations(), fetchIncomes(), fetchExpenses(), fetchRefereesTotalBalance?.()]);
    } catch (error) {
      console.error(error);
      toast.error('İşlem başarısız');
    } finally {
      setResTransferLoading(false);
    }
  };
  const addReservationExpense = async (e) => {
    e.preventDefault();
    const isCross = newReservationExpense.kind === 'cross_match_fee';
    if (isCross && !newReservationExpense.source_reservation_id) {
      toast.error('Ücretin alınamadığı maçı seçin');
      return;
    }
    if (!isCross && (!newReservationExpense.description || newReservationExpense.description.trim().length < 3)) {
      toast.error('Açıklama zorunludur (en az 3 karakter)');
      return;
    }
    
    try {
      let description = newReservationExpense.description;
      if (isCross) {
        const src = reservations.find(r => r.id === newReservationExpense.source_reservation_id);
        description = `Hakem ücreti başka maçtan alındı — ${src ? `${src.date} ${getCustomerName(src.customer_id)}` : 'maç'}`;
      }
      await axios.post(`${API}/reservation-expenses`, {
        reservation_id: selectedReservationDetail.id,
        amount: parseFloat(newReservationExpense.amount),
        description,
        date: selectedReservationDetail.date,
        kind: isCross ? 'cross_match_fee' : null,
        source_reservation_id: isCross ? newReservationExpense.source_reservation_id : null
      });
      
      toast.success(isCross ? 'Başka maçtan alınan hakem ücreti kaydedildi' : 'Ekstra gider eklendi');
      setNewReservationExpense({ amount: '', description: '', kind: 'normal', source_reservation_id: '' });
      
      // Giderleri yenile
      const response = await axios.get(`${API}/reservation-expenses/${selectedReservationDetail.id}`);
      setReservationExpenses(response.data || []);
      fetchExpenses(); // Kasayı yenile
      fetchAllReservationExpenses(); // Tüm giderleri yenile
      fetchRefereesTotalBalance();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Gider eklenirken hata oluştu');
    }
  };
  
  const deleteReservationExpense = async (expenseId) => {
    if (!window.confirm('Bu gideri silmek istediğinize emin misiniz?')) return;
    try {
      await axios.delete(`${API}/reservation-expenses/${expenseId}`);
      toast.success('Gider silindi');
      
      // Giderleri yenile
      const response = await axios.get(`${API}/reservation-expenses/${selectedReservationDetail.id}`);
      setReservationExpenses(response.data || []);
      fetchExpenses();
      fetchAllReservationExpenses();
    } catch (error) {
      toast.error('Gider silinemedi');
    }
  };

  // ==================== SİLME FONKSİYONLARI ====================
  
  const handleDeleteReservation = async (id) => {
    if (!window.confirm('Bu rezervasyonu silmek istediğinize emin misiniz?')) return;
    try {
      await axios.delete(`${API}/reservations/${id}`);
      toast.success('Rezervasyon silindi');
      refreshReservationTab();
    } catch (error) {
      toast.error('Rezervasyon silinemedi');
    }
  };

  const handleDeleteSalon = async (id) => {
    if (!window.confirm('Bu salonu silmek istediğinize emin misiniz?')) return;
    try {
      await axios.delete(`${API}/salons/${id}`);
      toast.success('Salon silindi');
      fetchSalons();
    } catch (error) {
      toast.error('Salon silinemedi');
    }
  };

  const handleDeleteIncome = async (id) => {
    if (!window.confirm('Bu gelir kaydını silmek istediğinize emin misiniz?')) return;
    try {
      await axios.delete(`${API}/incomes/${id}`);
      toast.success('Gelir kaydı silindi');
      fetchIncomes();
    } catch (error) {
      toast.error('Gelir kaydı silinemedi');
    }
  };

  const handleDeleteExpense = async (id) => {
    if (!window.confirm('Bu gider kaydını silmek istediğinize emin misiniz?')) return;
    try {
      await axios.delete(`${API}/expenses/${id}`);
      toast.success('Gider kaydı silindi');
      fetchExpenses();
    } catch (error) {
      toast.error('Gider kaydı silinemedi');
    }
  };

  const handleDeleteReferee = async (id) => {
    if (!window.confirm('Bu hakemi silmek istediğinize emin misiniz?')) return;
    try {
      await axios.delete(`${API}/referees/${id}`);
      toast.success('Hakem silindi');
      fetchReferees();
    } catch (error) {
      toast.error('Hakem silinemedi');
    }
  };

  const handleDeleteTeam = async (id) => {
    if (!window.confirm('Bu takımı silmek istediğinize emin misiniz?')) return;
    try {
      await axios.delete(`${API}/teams/${id}`);
      toast.success('Takım silindi');
      fetchTeams();
    } catch (error) {
      toast.error('Takım silinemedi');
    }
  };

  const handleDeleteMatch = async (id) => {
    if (!window.confirm('Bu maçı silmek istediğinize emin misiniz?')) return;
    try {
      await axios.delete(`${API}/matches/${id}`);
      toast.success('Maç silindi');
      fetchMatches();
    } catch (error) {
      toast.error('Maç silinemedi');
    }
  };

  const handleDeleteCustomer = async (id) => {
    if (!window.confirm('Bu müşteriyi silmek istediğinize emin misiniz?')) return;
    try {
      await axios.delete(`${API}/customers/${id}`);
      toast.success('Müşteri silindi');
      fetchCustomers();
    } catch (error) {
      toast.error('Müşteri silinemedi');
    }
  };

  // ==================== GÜNCELLEME FONKSİYONLARI ====================

  const handleUpdateReservation = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`${API}/reservations/${editingReservation.id}`, editingReservation);
      toast.success('Rezervasyon güncellendi');
      setShowEditReservationModal(false);
      // Rezervasyonlar sekmesinde görüntülenen ayı yeniden çek (global selectedMonth değil)
      // Kapora kasaya yazıldığı için gelir + müşteri bakiyesini de yenile
      await Promise.all([
        refreshReservationTab(),
        fetchIncomes(),
        fetchCustomers()
      ]);
    } catch (error) {
      toast.error('Rezervasyon güncellenemedi');
    }
  };

  const handleUpdateSalon = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`${API}/salons/${editingSalon.id}`, editingSalon);
      toast.success('Salon güncellendi');
      setShowEditSalonModal(false);
      fetchSalons();
    } catch (error) {
      toast.error('Salon güncellenemedi');
    }
  };

  const handleUpdateIncome = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`${API}/incomes/${editingIncome.id}`, editingIncome);
      toast.success('Gelir güncellendi');
      setShowEditIncomeModal(false);
      fetchIncomes();
    } catch (error) {
      toast.error('Gelir güncellenemedi');
    }
  };

  const handleUpdateExpense = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`${API}/expenses/${editingExpense.id}`, editingExpense);
      toast.success('Gider güncellendi');
      setShowEditExpenseModal(false);
      fetchExpenses();
    } catch (error) {
      toast.error('Gider güncellenemedi');
    }
  };

  const handleUpdateReferee = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`${API}/referees/${editingReferee.id}`, editingReferee);
      toast.success('Hakem güncellendi');
      setShowEditRefereeModal(false);
      fetchReferees();
    } catch (error) {
      toast.error('Hakem güncellenemedi');
    }
  };

  const handleUpdateTeam = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`${API}/teams/${editingTeam.id}`, editingTeam);
      toast.success('Takım güncellendi');
      setShowEditTeamModal(false);
      fetchTeams();
    } catch (error) {
      toast.error('Takım güncellenemedi');
    }
  };

  const handleUpdateMatch = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`${API}/matches/${editingMatch.id}`, editingMatch);
      toast.success('Maç güncellendi');
      setShowEditMatchModal(false);
      fetchMatches();
    } catch (error) {
      toast.error('Maç güncellenemedi');
    }
  };

  const openTeamDetail = (team) => {
    setSelectedTeam(team);
    // Takımın maçlarını getir
    const teamMatchList = matches.filter(m => 
      m.home_team_id === team.id || m.away_team_id === team.id
    );
    setTeamMatches(teamMatchList);
    setShowTeamDetailModal(true);
  };

  // Fatura durumunu güncelle
  const updateInvoiceStatus = async (reservationId, invoiceIssued) => {
    try {
      await axios.put(`${API}/reservations/${reservationId}/invoice-status`, {
        invoice_issued: invoiceIssued
      });
      toast.success(invoiceIssued ? 'Fatura kesildi olarak işaretlendi' : 'Fatura durumu kaldırıldı');
      refreshReservationTab();
    } catch (error) {
      console.error('Fatura durumu güncellenemedi:', error);
      toast.error('Fatura durumu güncellenemedi');
    }
  };

  // Filtrelenmiş rezervasyonlar
  const getFilteredReservations = () => {
    return reservations.filter(res => {
      // Aylık filtreleme (önce bu kontrol edilmeli)
      if (res.date) {
        const resDate = new Date(res.date);
        if (resDate.getMonth() !== reservationMonth || resDate.getFullYear() !== reservationYear) {
          return false;
        }
      }
      
      // Salon filtresi
      if (reservationFilters.salon_id !== 'all' && res.salon_id !== reservationFilters.salon_id) return false;
      
      // Hakem filtresi
      if (reservationFilters.referee_id !== 'all') {
        if (reservationFilters.referee_id === 'none' && res.referee_id) return false;
        if (reservationFilters.referee_id !== 'none' && res.referee_id !== reservationFilters.referee_id) return false;
      }
      
      // Ödeme durumu filtresi (overdue = faturalı, ödenmemiş ve vadesi geçmiş)
      if (reservationFilters.payment_status === 'overdue') {
        const today = new Date(Date.now() + 3 * 3600 * 1000).toISOString().slice(0, 10);
        if (!(res.invoice_issued && res.payment_status !== 'odendi'
              && res.invoice_due_date && String(res.invoice_due_date).slice(0, 10) < today)) return false;
      } else if (reservationFilters.payment_status !== 'all' && res.payment_status !== reservationFilters.payment_status) return false;
      
      // Fatura durumu filtresi
      if (reservationFilters.invoice_status !== 'all') {
        if (reservationFilters.invoice_status === 'issued' && !res.invoice_issued) return false;
        if (reservationFilters.invoice_status === 'not_issued' && res.invoice_issued) return false;
      }
      
      // Tarih filtresi (aylık filtrenin içinde ek tarih aralığı)
      if (reservationFilters.date_from && res.date < reservationFilters.date_from) return false;
      if (reservationFilters.date_to && res.date > reservationFilters.date_to) return false;
      
      return true;
    });
  };

  // Ay isimleri
  const MONTHS = [
    'Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran',
    'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'
  ];

  // Ödeme yöntemi (kasa) etiketleri
  const getPaymentMethodLabel = (pm) => {
    if (pm === 'enpara') return '';  // Enpara kaldırıldı — işlemler boş görünür
    const labels = {
      nakit: '💵 Nakit',
      garanti_bbva: '🏦 Garanti BBVA',
      bostanci: '🏢 Bostancı',
      banka_havalesi: '🏦 Banka Havalesi'
    };
    return labels[pm] || (pm || 'Nakit');
  };

  // Rezervasyon net tutarı (backend referee-balance ile birebir):
  // net = toplam − kapora − hakem ücreti − ekstra giderler
  // Hakemli maçta kapora HER ZAMAN düşülür; hakemsizde "odendi" iken paid_amount=total olduğundan düşülmez.
  const getReservationKapora = (reservation) => {
    const hasRef = !!reservation.referee_id && reservation.referee_id !== 'null';
    // Hakemli maçta kapora HER ZAMAN düşülür (ödeme durumundan bağımsız).
    // Hakemsiz rezervasyon ödendiğinde tamamı kasada kalır → kapora düşülmez.
    if (hasRef) return reservation.paid_amount || 0;
    return reservation.payment_status !== 'odendi' ? (reservation.paid_amount || 0) : 0;
  };

  const calcReservationNet = (reservation) => {
    // Havale ile bankaya ödendiyse VEYA faturalı işlemse hakemin elinde nakit olmaz
    if (reservation.paid_via_transfer || reservation.invoice_issued) return 0;
    const kapora = getReservationKapora(reservation);
    const online = reservation.referee_report_online_amount || 0;
    const volly = reservation.referee_report_volly_amount || 0;
    let totalExpenses;
    if (reservation.referee_report_status === 'submitted' || reservation.referee_report_status === 'delivered') {
      totalExpenses = (reservation.referee_report_expenses || []).reduce((s, e) => s + (e.amount || 0), 0);
    } else {
      totalExpenses = allReservationExpenses
        .filter(e => e.reservation_id === reservation.id)
        .reduce((s, e) => s + (e.amount || 0), 0);
    }
    return Math.max(0, (reservation.total_amount || 0)
      - (reservation.referee_fee || 0)
      - totalExpenses
      - kapora
      - online
      - volly);
  };

  // Rezervasyon ayını değiştir
  const changeReservationMonth = (direction) => {
    let newMonth = reservationMonth + direction;
    let newYear = reservationYear;
    
    if (newMonth < 0) {
      newMonth = 11;
      newYear -= 1;
    } else if (newMonth > 11) {
      newMonth = 0;
      newYear += 1;
    }
    
    setReservationMonth(newMonth);
    setReservationYear(newYear);
    // Seçilen ayın rezervasyonlarını backend'den yeniden çek (geçmiş aylar da görünsün)
    const monthStr = `${newYear}-${String(newMonth + 1).padStart(2, '0')}`;
    fetchReservations(monthStr);
  };

  // Bugüne git
  const goToCurrentReservationMonth = () => {
    const now = new Date();
    setReservationMonth(now.getMonth());
    setReservationYear(now.getFullYear());
    const monthStr = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
    fetchReservations(monthStr);
  };

  const isCurrentReservationMonth = reservationMonth === new Date().getMonth() && reservationYear === new Date().getFullYear();

  // Filtrelenmiş müşteriler
  const getFilteredCustomers = () => {
    return customers.filter(customer => {
      // İsim/Telefon/Email arama
      if (customerFilters.search) {
        const searchLower = customerFilters.search.toLowerCase();
        const nameMatch = customer.name?.toLowerCase().includes(searchLower);
        const phoneMatch = customer.phone?.toLowerCase().includes(searchLower);
        const emailMatch = customer.email?.toLowerCase().includes(searchLower);
        if (!nameMatch && !phoneMatch && !emailMatch) return false;
      }
      
      // Bakiye durumu filtresi
      if (customerFilters.balance_status !== 'all') {
        if (customerFilters.balance_status === 'has_debt' && (!customer.balance || customer.balance <= 0)) return false;
        if (customerFilters.balance_status === 'no_debt' && customer.balance > 0) return false;
      }
      
      return true;
    });
  };
  
  // Filtrelenmiş hakemler
  const getFilteredReferees = () => {
    return referees.filter(referee => {
      // İsim/Telefon arama
      if (personnelFilters.search) {
        const searchLower = personnelFilters.search.toLowerCase();
        const nameMatch = referee.name?.toLowerCase().includes(searchLower);
        const phoneMatch = referee.phone?.toLowerCase().includes(searchLower);
        if (!nameMatch && !phoneMatch) return false;
      }
      
      // Seviye filtresi
      if (personnelFilters.level !== 'all' && referee.level !== personnelFilters.level) return false;
      
      return true;
    });
  };

  // Hakem istatistikleri
  const getRefereeStats = () => {
    const filtered = getFilteredReferees();
    const totalEarnings = filtered.reduce((sum, r) => sum + (r.total_earnings || 0), 0);
    const totalMatches = filtered.reduce((sum, r) => sum + (r.total_matches || 0), 0);
    
    return {
      total: filtered.length,
      totalEarnings,
      totalMatches,
      avgPerMatch: totalMatches > 0 ? (totalEarnings / totalMatches).toFixed(0) : 0
    };
  };

  // Müşteri istatistikleri
  const getCustomerStats = () => {
    const filtered = getFilteredCustomers();
    const totalDebt = filtered.reduce((sum, c) => sum + (c.balance > 0 ? c.balance : 0), 0);
    const customersWithDebt = filtered.filter(c => c.balance > 0).length;
    const totalReservations = filtered.reduce((sum, c) => {
      return sum + reservations.filter(r => r.customer_id === c.id).length;
    }, 0);
    
    return {
      total: filtered.length,
      totalDebt,
      customersWithDebt,
      totalReservations
    };
  };

  // Analiz hesaplamaları
  const openRefereeDetail = async (referee) => {
    setSelectedReferee(referee);
    setShowRefereeDetailModal(true);
    
    try {
      // Finansal özeti getir
      const financialRes = await axios.get(`${API}/referees/${referee.id}/financial-summary`);
      setRefereeFinancial(financialRes.data);
      
      // Ödeme geçmişini getir
      const paymentsRes = await axios.get(`${API}/referee-payments?referee_id=${referee.id}`);
      setRefereePayments(paymentsRes.data);
    } catch (error) {
      console.error('Hakem detayları getirilemedi:', error);
      toast.error('Hakem detayları getirilemedi');
    }
  };
  
  // Hakemden para teslim alma işlemi
  const handleRefereePaymentCollected = async (reservationId, netAmount, collected) => {
    try {
      const reservation = reservations.find(r => r.id === reservationId);
      const customer = customers.find(c => c.id === reservation?.customer_id);
      
      // Rezervasyonu güncelle
      await axios.put(`${API}/reservations/${reservationId}`, {
        referee_payment_collected: collected
      });
      
      if (collected) {
        // Para teslim alındıysa kasaya tahsilat olarak ekle
        await axios.post(`${API}/referee-payments`, {
          referee_id: reservation?.referee_id,
          amount: netAmount,
          payment_type: 'tahsilat',
          date: new Date().toISOString().split('T')[0],
          notes: `Maç tahsilatı: ${customer?.name || 'Müşteri'} - ${reservation?.date} (${reservation?.start_time?.slice(0,5)}-${reservation?.end_time?.slice(0,5)})`
        });
        
        toast.success(`₺${netAmount.toLocaleString()} kasaya tahsil edildi`);
      } else {
        // Para teslim geri alındıysa kasadan ve hakem ödemelerinden sil
        await axios.delete(`${API}/referee-payment-by-reservation/${reservationId}`);
        
        toast.warning(`₺${netAmount.toLocaleString()} kasadan düşüldü`);
      }
      
      // Verileri yenile
      fetchReservations();
      fetchIncomes();
      fetchRefereesTotalBalance();
      if (selectedReferee) {
        openRefereeDetail(selectedReferee);
      }
    } catch (error) {
      console.error('İşlem hatası:', error);
      toast.error('İşlem sırasında hata oluştu');
    }
  };

  // Hakem panelinden ekstra gider ekleme (hakemin kendi panelinden)
  const createRefereeExpenseFromPanel = async (e) => {
    e.preventDefault();
    
    if (!refereeExpense.notes || refereeExpense.notes.trim().length < 3) {
      toast.error('Ekstra gider için açıklama zorunludur (en az 3 karakter)');
      return;
    }
    
    try {
      await axios.post(`${API}/referee-payments`, {
        referee_id: currentUser.referee_id,
        amount: parseFloat(refereeExpense.amount),
        payment_type: 'gider',
        date: selectedExpenseReservation?.date || new Date().toISOString().split('T')[0],
        notes: `Maç: ${selectedExpenseReservation?.customer_name} (${selectedExpenseReservation?.date}) - ${refereeExpense.notes}`
      });
      
      toast.success('Ekstra gider kaydedildi ve kasaya işlendi');
      setRefereeExpense({ amount: '', notes: '' });
      setShowRefereeExpenseModal(false);
      setSelectedExpenseReservation(null);
      
      // Verileri yenile
      fetchRefereeData();
    } catch (error) {
      toast.error('Gider eklenirken hata oluştu');
    }
  };

  // ==================== PERSONEL ÖDEME FONKSİYONLARI ====================
  
  const openPersonnelDetail = async (person) => {
    setSelectedPersonnel(person);
    setShowPersonnelDetailModal(true);
    
    try {
      // Ödemeleri getir
      const paymentsRes = await axios.get(`${API}/personnel-payments/${person.id}`);
      setPersonnelPayments(paymentsRes.data);
      
      // Özet bilgiyi getir
      const summaryRes = await axios.get(`${API}/personnel/${person.id}/summary`);
      setPersonnelSummary(summaryRes.data);
    } catch (error) {
      console.error('Personel detayları getirilemedi:', error);
      toast.error('Personel detayları getirilemedi');
    }
  };
  
  const createPersonnelPayment = async (e) => {
    e.preventDefault();
    
    try {
      await axios.post(`${API}/personnel-payments`, {
        personnel_id: selectedPersonnel.id,
        amount: parseFloat(newPersonnelPayment.amount),
        payment_type: newPersonnelPayment.payment_type,
        date: newPersonnelPayment.date,
        month: newPersonnelPayment.month,
        notes: newPersonnelPayment.notes
      });
      
      const paymentTypeText = {
        'maas': 'Maaş',
        'avans': 'Avans',
        'prim': 'Prim',
        'diger': 'Diğer'
      }[newPersonnelPayment.payment_type] || 'Ödeme';
      
      toast.success(`${paymentTypeText} ödemesi kaydedildi`);
      setNewPersonnelPayment({
        amount: '',
        payment_type: 'maas',
        date: new Date().toISOString().split('T')[0],
        month: new Date().toISOString().slice(0, 7),
        notes: ''
      });
      
      // Verileri yenile
      openPersonnelDetail(selectedPersonnel);
      fetchExpenses();
    } catch (error) {
      toast.error('Ödeme kaydedilemedi');
    }
  };
  
  const deletePersonnelPayment = async (paymentId) => {
    if (!window.confirm('Bu ödemeyi silmek istediğinize emin misiniz? Kasadan da düşülecektir.')) return;
    
    try {
      await axios.delete(`${API}/personnel-payments/${paymentId}`);
      toast.success('Ödeme silindi ve kasadan düşüldü');
      openPersonnelDetail(selectedPersonnel);
      fetchExpenses();
    } catch (error) {
      toast.error('Ödeme silinemedi');
    }
  };

  const createRefereePayment = async (e) => {
    e.preventDefault();
    
    // Gider için açıklama zorunlu kontrolü
    if (newRefereePayment.payment_type === 'gider' && (!newRefereePayment.notes || newRefereePayment.notes.trim().length < 3)) {
      toast.error('Ekstra gider için açıklama zorunludur (en az 3 karakter)');
      return;
    }
    
    try {
      await axios.post(`${API}/referee-payments`, {
        referee_id: selectedReferee.id,
        ...newRefereePayment,
        amount: parseFloat(newRefereePayment.amount)
      });
      
      const paymentTypeText = 
        newRefereePayment.payment_type === 'tahsilat' ? 'Tahsilat kaydı eklendi' : 
        newRefereePayment.payment_type === 'gider' ? 'Ekstra gider kasaya eklendi' : 
        'Ödeme kaydı eklendi';
      toast.success(paymentTypeText);
      setNewRefereePayment({
        amount: '',
        payment_type: 'tahsilat',
        date: new Date().toISOString().split('T')[0],
        notes: ''
      });
      
      // Verileri yenile
      openRefereeDetail(selectedReferee);
      fetchIncomes(); // Kasayı yenile
      fetchExpenses(); // Giderleri yenile (ekstra gider kasaya gider olarak ekleniyor)
      fetchAnalytics(); // Finansal özeti yenile
      fetchRefereesTotalBalance(); // Hakemlerden alınacak tutarı yenile
    } catch (error) {
      console.error('İşlem eklenemedi:', error);
      toast.error(error.response?.data?.detail || 'İşlem eklenemedi');
    }
  };

  const createReservation = async (e) => {
    e.preventDefault();
    try {
      const reservationData = {
        ...newReservation,
        duration_hours: calcDurationHours(newReservation.start_time, newReservation.end_time),
        paid_amount: parseFloat(newReservation.paid_amount) || 0,
        total_amount: newReservation.total_amount !== '' ? parseFloat(newReservation.total_amount) : null,
        referee_fee: newReservation.referee_fee ? parseFloat(newReservation.referee_fee) : null
      };
      
      await axios.post(`${API}/reservations`, reservationData);
      toast.success('Rezervasyon başarıyla oluşturuldu');
      setNewReservation({
        salon_id: '',
        customer_id: '',
        date: new Date().toISOString().split('T')[0],
        start_time: '',
        end_time: '',
        duration_hours: 1,
        payment_method: 'nakit',
        paid_amount: '',
        total_amount: '',
        referee_id: '',
        referee_fee: '',
        invoice_issued: false,
        notes: ''
      });
      refreshReservationTab();
      fetchTodayReservations();
      fetchAnalytics();
      fetchCustomers();
      fetchReferees(); // Hakem istatistiklerini yenile
      fetchRefereesTotalBalance(); // Hakemlerden alınacak tutarı yenile
    } catch (error) {
      console.error('Rezervasyon oluşturulamadı:', error);
      toast.error(error.response?.data?.detail || 'Rezervasyon oluşturulamadı');
    }
  };

  const createIncome = async (e) => {
    e.preventDefault();
    try {
      const incomeData = {
        ...newIncome,
        amount: parseFloat(newIncome.amount)
      };
      
      await axios.post(`${API}/incomes`, incomeData);
      toast.success('Gelir başarıyla eklendi');
      setNewIncome({
        title: '',
        amount: '',
        category: 'diger',
        date: new Date().toISOString().split('T')[0],
        notes: ''
      });
      fetchIncomes();
      fetchAnalytics();
    } catch (error) {
      console.error('Gelir eklenemedi:', error);
      toast.error('Gelir eklenemedi');
    }
  };

  const createExpense = async (e) => {
    e.preventDefault();
    try {
      const expenseData = {
        ...newExpense,
        amount: parseFloat(newExpense.amount)
      };
      
      await axios.post(`${API}/expenses`, expenseData);
      toast.success('Gider başarıyla eklendi');
      setNewExpense({
        title: '',
        amount: '',
        category: 'diger',
        date: new Date().toISOString().split('T')[0],
        notes: ''
      });
      fetchExpenses();
      fetchAnalytics();
    } catch (error) {
      console.error('Gider eklenemedi:', error);
      toast.error('Gider eklenemedi');
    }
  };

  const deleteIncome = async (incomeId) => {
    try {
      await axios.delete(`${API}/incomes/${incomeId}`);
      toast.success('Gelir kaydı silindi');
      fetchIncomes();
      fetchAnalytics();
    } catch (error) {
      console.error('Gelir silinemedi:', error);
      toast.error('Gelir silinemedi');
    }
  };

  const deleteExpense = async (expenseId) => {
    try {
      await axios.delete(`${API}/expenses/${expenseId}`);
      toast.success('Gider kaydı silindi');
      fetchExpenses();
      fetchAnalytics();
    } catch (error) {
      console.error('Gider silinemedi:', error);
      toast.error('Gider silinemedi');
    }
  };

  const createCategory = async (e) => {
    e.preventDefault();
    try {
      if (!newCategory.name.trim()) {
        toast.error('Kategori adı boş olamaz');
        return;
      }
      await axios.post(`${API}/categories`, newCategory);
      toast.success('Kategori başarıyla eklendi');
      setNewCategory({ name: '', type: 'income' });
      fetchCategories();
    } catch (error) {
      console.error('Kategori eklenemedi:', error);
      toast.error('Kategori eklenemedi');
    }
  };

  const deleteCategory = async (categoryId) => {
    if (window.confirm('Bu kategoriyi silmek istediğinizden emin misiniz?')) {
      try {
        await axios.delete(`${API}/categories/${categoryId}`);
        toast.success('Kategori silindi');
        fetchCategories();
      } catch (error) {
        console.error('Kategori silinemedi:', error);
        toast.error('Kategori silinemedi');
      }
    }
  };

  const createTeam = async (e) => {
    e.preventDefault();
    try {
      const teamData = {
        ...newTeam,
        registration_fee: parseFloat(newTeam.registration_fee) || 0,
        match_fee_per_game: parseFloat(newTeam.match_fee_per_game) || 0
      };
      
      await axios.post(`${API}/teams`, teamData);
      toast.success('Takım başarıyla eklendi');
      setNewTeam({ name: '', captain: '', phone: '', logo_url: '', registration_fee: '', match_fee_per_game: '' });
      fetchTeams();
      fetchLeagueStats();
      fetchIncomes();
    } catch (error) {
      console.error('Takım eklenemedi:', error);
      toast.error('Takım eklenemedi');
    }
  };

  const createMatch = async (e) => {
    e.preventDefault();
    try {
      const matchData = {
        ...newMatch,
        week: parseInt(newMatch.week),
        referee_fee: parseFloat(newMatch.referee_fee) || 0,
        home_team_payment_amount: parseFloat(newMatch.home_team_payment_amount) || 0,
        away_team_payment_amount: parseFloat(newMatch.away_team_payment_amount) || 0,
        field_rent: parseFloat(newMatch.field_rent) || 0,
        other_expenses: parseFloat(newMatch.other_expenses) || 0
      };
      
      await axios.post(`${API}/matches`, matchData);
      toast.success('Maç başarıyla oluşturuldu!');
      setNewMatch({
        home_team_id: '',
        away_team_id: '',
        date: new Date().toISOString().split('T')[0],
        time: '19:00',
        week: 1,
        match_type: 'lig_maci',
        salon_id: '',
        referee_id: '',
        referee_fee: '',
        home_team_payment_amount: '',
        away_team_payment_amount: '',
        field_rent: '',
        other_expenses: '',
        notes: ''
      });
      setShowAddMatchModal(false);
      fetchMatches();
      fetchLeagueStats();
      fetchIncomes();
      fetchExpenses();
    } catch (error) {
      console.error('Maç eklenemedi:', error);
      toast.error('Maç eklenemedi');
    }
  };

  const deleteMatch = async (matchId) => {
    if (!window.confirm('Bu maçı silmek istediğinize emin misiniz?')) return;
    try {
      await axios.delete(`${API}/matches/${matchId}`);
      toast.success('Maç silindi');
      fetchMatches();
      fetchLeagueStats();
    } catch (error) {
      toast.error('Maç silinemedi');
    }
  };

  const deleteTeam = async (teamId) => {
    if (!window.confirm('Bu takımı silmek istediğinize emin misiniz?')) return;
    try {
      await axios.delete(`${API}/teams/${teamId}`);
      toast.success('Takım silindi');
      fetchTeams();
      fetchLeagueStats();
    } catch (error) {
      toast.error('Takım silinemedi');
    }
  };

  const createReferee = async (e) => {
    e.preventDefault();
    try {
      const refereeData = {
        ...newReferee,
        fee_per_match: parseFloat(newReferee.fee_per_match)
      };
      
      await axios.post(`${API}/referees`, refereeData);
      toast.success('Hakem başarıyla eklendi');
      setNewReferee({ name: '', phone: '', level: 'junior', fee_per_match: '' });
      fetchReferees();
    } catch (error) {
      console.error('Hakem eklenemedi:', error);
      toast.error('Hakem eklenemedi');
    }
  };

  const updatePaymentStatus = async (reservationId, newStatus, paymentMethod) => {
    try {
      await axios.put(`${API}/reservations/${reservationId}/payment-status`, {
        payment_status: newStatus,
        ...(paymentMethod ? { payment_method: paymentMethod } : {})
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
      toast.success('Ödeme durumu güncellendi');
      
      // Tüm verileri yenile
      await Promise.all([
        refreshReservationTab(),
        fetchTodayReservations(),
        fetchAnalytics(),
        fetchIncomes(),  // Kasa verilerini yenile
        fetchCustomers()  // Müşteri bakiyelerini yenile
      ]);
      
    } catch (error) {
      console.error('Ödeme durumu güncellenemedi:', error);
      toast.error('Ödeme durumu güncellenemedi');
    }
  };

  // Bir rezervasyonun hakemi var mı? (referee_id geçerli olması yeterli; ücret 0 olsa bile hakemli sayılır)
  const reservationHasReferee = (reservation) =>
    !!reservation.referee_id && reservation.referee_id !== 'null';

  // Ödeme durumu dropdown değişimi.
  // Hakemsiz rezervasyon "Ödendi" yapılınca kasaya hangi hesaba yazılacağını seçtir.
  const handlePaymentStatusChange = (reservation, value) => {
    if (value === 'odendi' && !reservationHasReferee(reservation)) {
      setPayMethodTarget(reservation);
      setPayMethodChoice(reservation.payment_method || 'nakit');
      setShowPayMethodModal(true);
    } else {
      // Hakemli "Ödendi" (kasaya yazılmaz, hakemden tahsil edilecek) veya "Ödenmedi" → doğrudan
      updatePaymentStatus(reservation.id, value);
    }
  };

  // Hesap seçimi onayı → seçilen kasaya gelir yazılarak ödendi işaretlenir
  const confirmPayMethod = async () => {
    if (!payMethodTarget) return;
    setPayMethodLoading(true);
    try {
      await updatePaymentStatus(payMethodTarget.id, 'odendi', payMethodChoice);
      setShowPayMethodModal(false);
      setPayMethodTarget(null);
    } finally {
      setPayMethodLoading(false);
    }
  };

  const getSalonColor = (salonId) => {
    const colors = [
      'bg-gradient-to-r from-blue-500 to-blue-600',
      'bg-gradient-to-r from-green-500 to-green-600', 
      'bg-gradient-to-r from-purple-500 to-purple-600',
      'bg-gradient-to-r from-orange-500 to-orange-600',
      'bg-gradient-to-r from-pink-500 to-pink-600',
      'bg-gradient-to-r from-indigo-500 to-indigo-600',
      'bg-gradient-to-r from-teal-500 to-teal-600',
      'bg-gradient-to-r from-red-500 to-red-600'
    ];
    
    const index = salonId ? Math.abs(salonId.split('').reduce((a, b) => a + b.charCodeAt(0), 0)) % colors.length : 0;
    return colors[index];
  };

  const getPaymentStatusBadge = (status) => {
    switch (status) {
      case 'odendi':
        return <Badge className="bg-green-100 text-green-800 hover:bg-green-100"><CheckCircle className="w-3 h-3 mr-1" />Ödendi</Badge>;
      case 'odenmedi':
        return <Badge className="bg-red-100 text-red-800 hover:bg-red-100"><XCircle className="w-3 h-3 mr-1" />Ödenmedi</Badge>;
      default:
        return <Badge variant="secondary">{status}</Badge>;
    }
  };

  const getSalonName = (salonId) => {
    const salon = salons.find(s => s.id === salonId);
    return salon ? salon.name : 'Bilinmeyen Salon';
  };

  const getCustomerName = (customerId) => {
    const customer = customers.find(c => c.id === customerId);
    return customer ? customer.name : 'Bilinmeyen Müşteri';
  };

  const getRefereeNameById = (refereeId) => {
    const referee = referees.find(r => r.id === refereeId);
    return referee ? referee.name : 'Bilinmeyen Hakem';
  };

  const getCustomerReservations = async (customerId) => {
    try {
      const response = await axios.get(`${API}/customers/${customerId}/reservations`);
      setCustomerReservations(response.data);
      const customer = customers.find(c => c.id === customerId);
      setSelectedCustomer(customer);
      setShowCustomerModal(true);
    } catch (error) {
      console.error('Müşteri rezervasyonları alınamadı:', error);
      toast.error('Müşteri rezervasyonları alınamadı');
    }
  };

  const getCategoryName = (categoryId, type) => {
    // Önce dinamik kategorilerde ara
    const category = categories.find(cat => cat.id === categoryId);
    if (category) {
      return category.name;
    }
    
    // Eski sabit kategoriler için fallback (geriye dönük uyumluluk)
    const incomeCategories = {
      'rezervasyon': 'Rezervasyon',
      'kurs_ucreti': 'Kurs Ücreti',
      'etkinlik': 'Etkinlik',
      'lig_geliri': 'Lig Geliri',
      'diger': 'Diğer'
    };
    
    const expenseCategories = {
      'maas': 'Maaş',
      'kira': 'Kira',
      'faturalar': 'Faturalar',
      'malzeme': 'Malzeme',
      'bakim': 'Bakım',
      'lig_gideri': 'Lig Gideri',
      'diger': 'Diğer'
    };
    
    return type === 'income' ? (incomeCategories[categoryId] || categoryId) : (expenseCategories[categoryId] || categoryId);
  };

  // Authentication functions
  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${API}/auth/login`, loginForm);
      const userData = response.data.user;
      
      localStorage.setItem('token', response.data.access_token);
      localStorage.setItem('user', JSON.stringify(userData));
      
      setCurrentUser(userData);
      setShowLogin(false);
      
      // Role bazlı veri yükleme
      if (userData.role === 'hakem') {
        fetchRefereeData(userData.referee_id);
      } else if (userData.role === 'personel') {
        // Personel girişinde varsayılan sekme Dashboard (finansal bilgiler yetkiye göre gizlenir)
        setActiveTab('dashboard');
        fetchSalons();
        fetchCustomers();
        fetchReservations();
        fetchTodayReservations();
        fetchTeams();
        fetchMatches();
        fetchReferees();
      } else {
        // Admin ise tüm verileri getir
        fetchSalons();
        fetchCustomers();
        fetchReservations();
        fetchTodayReservations();
        fetchAnalytics();
        fetchIncomes();
        fetchExpenses();
        fetchCategories();
        fetchTeams();
        fetchMatches();
        fetchReferees();
        fetchPersonnel();
        fetchEvents();
      }
      
      toast.success(`Hoş geldiniz ${userData.username}!`);
    } catch (error) {
      console.error('Giriş hatası:', error);
      toast.error('Kullanıcı adı veya şifre hatalı');
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setCurrentUser(null);
    setShowLogin(true);
    setRefereeData(null);
  };

  const fetchRefereeData = async (refereeId) => {
    try {
      // Tüm hakem verilerini paralel olarak getir
      const [dashboardRes, financialRes, reservationsRes] = await Promise.all([
        axios.get(`${API}/referees/${refereeId}/dashboard`).catch(() => ({ data: null })),
        axios.get(`${API}/referees/${refereeId}/financial-summary`).catch(() => ({ data: null })),
        axios.get(`${API}/referees/${refereeId}/my-reservations`).catch(() => ({ data: [] }))
      ]);
      
      setRefereeData({
        ...dashboardRes.data,
        financial: financialRes.data,
        reservations: reservationsRes.data
      });
    } catch (error) {
      console.error('Hakem verisi alınamadı:', error);
    }
  };

  // Hakem ödeme aldığını işaretler
  const updatePaymentCollected = async (reservationId, collected) => {
    try {
      await axios.put(`${API}/reservations/${reservationId}/payment-collected`, {
        payment_collected: collected
      });
      toast.success(collected ? 'Ödeme alındı olarak işaretlendi' : 'Ödeme durumu kaldırıldı');
      
      // Verileri yenile
      if (currentUser?.referee_id) {
        fetchRefereeData(currentUser.referee_id);
      }
    } catch (error) {
      console.error('Ödeme durumu güncellenemedi:', error);
      toast.error('Ödeme durumu güncellenemedi');
    }
  };

  const resetAllData = async () => {
    if (window.confirm('⚠️ DİKKAT!\n\nTüm veriler silinecek:\n- Rezervasyonlar\n- Müşteriler\n- Hakemler\n- Takımlar\n- Maçlar\n- Gelir-Gider kayıtları\n\nBu işlem geri alınamaz! Emin misiniz?')) {
      try {
        await axios.delete(`${API}/admin/reset-all-data`);
        toast.success('Tüm veriler başarıyla temizlendi!');
        
        // State'leri sıfırla
        setSalons([]);
        setCustomers([]);
        setReservations([]);
        setTodayReservations([]);
        setIncomes([]);
        setExpenses([]);
        setTeams([]);
        setMatches([]);
        setReferees([]);
        setFinancialSummary(null);
        setDailyRevenue(null);
        setMonthlyRevenue(null);
        
        // Verileri yenile
        fetchAnalytics();
        
      } catch (error) {
        console.error('Veri sıfırlama hatası:', error);
        toast.error('Veri sıfırlama sırasında hata oluştu');
      }
    }
  };

  // Excel Export Functions
  const exportCustomersToExcel = async () => {
    try {
      toast.info('Excel dosyası hazırlanıyor...');
      const response = await axios.get(`${API}/export/customers`, {
        responseType: 'blob'
      });
      
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `musteriler_${new Date().toISOString().split('T')[0]}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      
      toast.success('Müşteriler Excel dosyası indirildi!');
    } catch (error) {
      console.error('Excel export hatası:', error);
      toast.error('Excel dosyası oluşturulamadı');
    }
  };

  const exportReservationsToExcel = async () => {
    try {
      toast.info('Excel dosyası hazırlanıyor...');
      const response = await axios.get(`${API}/export/reservations`, {
        responseType: 'blob'
      });
      
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `rezervasyonlar_${new Date().toISOString().split('T')[0]}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      
      toast.success('Rezervasyonlar Excel dosyası indirildi!');
    } catch (error) {
      console.error('Excel export hatası:', error);
      toast.error('Excel dosyası oluşturulamadı');
    }
  };

  const exportAnalyticsToExcel = async () => {
    try {
      toast.info('Excel dosyası hazırlanıyor...');
      const response = await axios.get(`${API}/export/analytics`, {
        responseType: 'blob'
      });
      
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `analiz_${new Date().toISOString().split('T')[0]}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      
      toast.success('Analiz Excel dosyası indirildi!');
    } catch (error) {
      console.error('Excel export hatası:', error);
      toast.error('Excel dosyası oluşturulamadı');
    }
  };

  // Global axios interceptor: her isteğe token ekle + 401 (oturum bitti) durumunda nazikçe çıkış yap
  useEffect(() => {
    // Sunucu yanıt vermezse istek sonsuza kadar beklemesin (kullanıcı dakikalarca bekliyordu)
    axios.defaults.timeout = 60000;
    const reqId = axios.interceptors.request.use((config) => {
      const t = localStorage.getItem('token');
      if (t) config.headers = { ...config.headers, Authorization: `Bearer ${t}` };
      return config;
    });
    const resId = axios.interceptors.response.use(
      (res) => res,
      (error) => {
        const status = error?.response?.status;
        const detail = error?.response?.data?.detail;
        const isAuthErr = status === 401 && typeof detail === 'string' &&
          (detail.includes('Token') || detail.includes('token') || detail.includes('Yetkilendirme'));
        const isLoginCall = (error?.config?.url || '').includes('/auth/login');
        if (isAuthErr && !isLoginCall) {
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          setCurrentUser(null);
          setShowLogin(true);
          // Toast'u bir sonraki tick'te göster: setShowLogin(true) login ekranını (kendi Toaster'ıyla)
          // mount ettikten sonra toast kuyruğa girsin, aksi halde Toaster remount'unda kaybolur.
          setTimeout(() => toast.error('Oturum süreniz doldu. Lütfen tekrar giriş yapın.'), 150);
        }
        return Promise.reject(error);
      }
    );
    return () => {
      axios.interceptors.request.eject(reqId);
      axios.interceptors.response.eject(resId);
    };
  }, []);

  // Sayfa yüklendiğinde token kontrolü
  useEffect(() => {
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('user');
    
    if (token && userData) {
      // Token süresi dolmuşsa oturumu temizle ve girişe yönlendir
      if (isTokenExpired(token)) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        setCurrentUser(null);
        setShowLogin(true);
        setTimeout(() => toast.error('Oturum süreniz doldu. Lütfen tekrar giriş yapın.'), 150);
        return;
      }
      try {
        const user = JSON.parse(userData);
        setCurrentUser(user);
        setShowLogin(false);
        
        if (user.role === 'hakem') {
          fetchRefereeData(user.referee_id);
        } else if (user.role === 'personel') {
          // Personel yetkilerini sunucudan tazele (admin yeni yetki verdiyse yeniden girişe gerek kalmadan yansısın)
          if (user.personnel_id) {
            axios.get(`${API}/personnel/${user.personnel_id}/permissions`)
              .then(res => {
                const freshPerms = res.data?.permissions;
                if (Array.isArray(freshPerms)) {
                  const updated = { ...user, permissions: freshPerms };
                  setCurrentUser(updated);
                  localStorage.setItem('user', JSON.stringify(updated));
                }
              })
              .catch(() => {});
          }
          // Personel için varsayılan sekme Dashboard
          setActiveTab('dashboard');
          fetchSalons();
          fetchCustomers();
          fetchReservations();
          fetchTodayReservations();
          fetchTeams();
          fetchMatches();
          fetchReferees();
        } else {
          fetchSalons();
          fetchCustomers();
          fetchReservations();
          fetchTodayReservations();
          fetchAnalytics();
          fetchIncomes();
          fetchExpenses();
          fetchCategories();
          fetchTeams();
          fetchMatches();
          fetchReferees();
          fetchPersonnel();
          fetchEvents();
        }
      } catch (error) {
        console.error('Token parse hatası:', error);
        handleLogout();
      }
    }
  }, []);

  // Landing Page and Login for Non-Logged In Users
  // ====== PUBLIC FEEDBACK ROUTE (herkese açık, giriş gerektirmez) ======
  if (typeof window !== 'undefined' && window.location.pathname.startsWith('/feedback/')) {
    const rid = window.location.pathname.replace(/^\/feedback\//, '').replace(/\/$/, '');
    return (
      <>
        <Toaster position="top-right" />
        <FeedbackPage reservationId={rid} />
      </>
    );
  }

  if (showLogin) {
    // ====== BLOG ROUTES ======
    if (typeof window !== 'undefined') {
      const path = window.location.pathname;
      if (path === '/blog' || path === '/blog/') {
        return (
          <>
            <Toaster position="top-right" />
            <BlogListPage />
          </>
        );
      }
      if (path.startsWith('/blog/')) {
        const slug = path.replace(/^\/blog\//, '').replace(/\/$/, '');
        return (
          <>
            <Toaster position="top-right" />
            <BlogArticlePage slug={slug} />
          </>
        );
      }
      // ====== ORGANIZATION DETAIL ROUTE ======
      if (path.startsWith('/organizasyon/')) {
        const slug = path.replace(/^\/organizasyon\//, '').replace(/\/$/, '');
        return (
          <>
            <Toaster position="top-right" />
            <EventDetailPage slug={slug} />
          </>
        );
      }
    }
    return (
      <>
        <Toaster position="top-right" />
        <LandingPage />
        
        {/* Login Modal - Only opens when button is clicked */}
        <Dialog open={showLoginModal} onOpenChange={(o) => {
          setShowLoginModal(o);
          if (!o && typeof window !== 'undefined' && window.location.pathname !== '/') {
            window.history.replaceState({}, '', '/');
          }
        }}>
          <DialogContent className="max-w-md">
            <DialogHeader>
              <div className="flex justify-center mb-4">
                <img 
                  src="https://customer-assets.emergentagent.com/job_17ae65fc-a3ab-44cd-ac8e-52289b6992ff/artifacts/m6249hnu_Sar%C4%B1%20Kurumsal%20Hukuk%20Dan%C4%B1%C5%9Fmanl%C4%B1%C4%9F%C4%B1%20Fatura.png" 
                  alt="Avrasya Logo" 
                  className="h-20 object-contain"
                />
              </div>
              <DialogTitle className="text-2xl font-bold text-center">Panel Girişi</DialogTitle>
            </DialogHeader>
            <form onSubmit={handleLogin} className="space-y-4 mt-4">
              <div>
                <Label htmlFor="username">Kullanıcı Adı</Label>
                <Input
                  id="username"
                  type="text"
                  placeholder="Kullanıcı adınızı girin"
                  value={loginForm.username}
                  onChange={(e) => setLoginForm({ ...loginForm, username: e.target.value })}
                  required
                />
              </div>
              <div>
                <Label htmlFor="password">Şifre</Label>
                <Input
                  id="password"
                  type="password"
                  placeholder="Şifrenizi girin"
                  value={loginForm.password}
                  onChange={(e) => setLoginForm({ ...loginForm, password: e.target.value })}
                  required
                />
              </div>
              <Button type="submit" className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700">
                Giriş Yap
              </Button>
            </form>
            <div className="mt-4 text-center text-xs text-gray-400">
              © 2025 Avrasya Sportif Faaliyetler
            </div>
          </DialogContent>
        </Dialog>
      </>
    );
  }

  // Hakem dashboard'ı
  if (currentUser?.role === 'hakem') {
    return <RefereePortal currentUser={currentUser} onLogout={handleLogout} />;
  }

  // Personel dashboard'ı (Kısıtlı erişim - Kasa ve Finansal bilgiler gizli)
  // Admin veya Personel dashboard (role bazlı erişim kontrolü ile)
  // Personel girişinde sadece belirli sekmeler görünür (Kasa, Analiz, Dashboard, Salonlar gizli)
  const isPersonnel = currentUser?.role === 'personel';
  const personnelPerms = (currentUser?.permissions || []);
  const hasPerm = (permId) => !isPersonnel || personnelPerms.includes(permId);
  // Rezervasyon dropdown başlıkları
  const canRezervasyon = !isPersonnel || ['takvim', 'rezervasyonlar', 'musteriler', 'salonlar'].some(p => personnelPerms.includes(p));
  const canKasa = !isPersonnel || ['kasa', 'analiz', 'hakemler', 'personel'].some(p => personnelPerms.includes(p));

  // Üst bardaki hızlı işlemler — gerçek kayıt formlarını açar
  const handleQuickAction = (key) => {
    if (key === 'organization') { setOrgAutoOpenNew(true); setActiveTab('organizations'); return; }
    if (key === 'income' || key === 'expense') {
      setFinancialsSubTab('ledger');
      setFinancialsQuickAction(key);
      setActiveTab('financials');
      return;
    }
    if (key === 'reservation') { setActiveTab('reservations'); setShowNewReservationDialog(true); return; }
    if (key === 'calendar') { setActiveTab('calendar'); return; }
    if (key === 'report') { setActiveTab('analytics'); }
  };

  // Admin/Personel dashboard (mevcut sistem) — kurumsal kabuk (AdminShell) içinde
  return (
    <AdminShell
      activeTab={activeTab}
      onNavigate={(tab, sub) => {
        if (tab === 'financials') setFinancialsSubTab(sub === 'fixed' ? 'fixed' : 'ledger');
        setActiveTab(tab);
      }}
      currentUser={currentUser}
      isPersonnel={isPersonnel}
      hasPerm={hasPerm}
      onLogout={handleLogout}
      onOpenSettings={openAdminSettingsModal}
      onResetData={resetAllData}
      onQuickAction={handleQuickAction}
    >
      {isPersonnel && <PersonnelMesaiBanner />}

      <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-4 md:space-y-5">
          {/* Dashboard — kurumsal yönetici kontrol merkezi */}
          <TabsContent value="dashboard" className="space-y-4">
            <DashboardHome
              currentUser={currentUser}
              isPersonnel={isPersonnel}
              canFinance={!isPersonnel || ['kasa', 'gunsonu', 'analiz'].some(p => personnelPerms.includes(p))}
              onNavigate={(tab, payload) => {
                if (payload?.customerId) setFocusCustomerId(payload.customerId);
                if (payload?.refereeId) setFocusRefereeId(payload.refereeId);
                setActiveTab(tab);
              }}
            />
          </TabsContent>

          {/* Calendar Tab - Refactored */}
          <TabsContent value="calendar" className="space-y-4">
            <CalendarTab
              reservations={reservations}
              salons={salons}
              customers={customers}
              referees={referees}
              organizations={calendarOrganizations}
              onNavigate={(tab, payload) => {
                if (payload?.customerId) setFocusCustomerId(payload.customerId);
                setActiveTab(tab);
              }}
              fetchReservations={fetchReservations}
              fetchIncomes={fetchIncomes}
              onQuickReservation={(data) => {
                setNewReservation({
                  ...newReservation,
                  date: data.date,
                  start_time: data.time,
                  salon_id: data.salon_id,
                  customer_id: data.customer_id || ''
                });
                setActiveTab('reservations');
                setShowNewReservationDialog(true);
              }}
            />
          </TabsContent>

          {/* Reservations Tab - Corporate */}
          <TabsContent value="reservations" className="space-y-4">
            {/* ===== Kurumsal başlık + ay seçici + filtre şeridi ===== */}
            <PageHeader
              icon={Clock}
              title="Rezervasyonlar"
              description="Saat takibi, ödeme durumu, hakem ve fatura yönetimi"
              testid="reservations-header"
              actions={
                <>
                  <div className="flex items-center gap-1 rounded-lg border border-[#E2E8F0] bg-white p-1">
                    <Button variant="ghost" size="sm" onClick={() => changeReservationMonth(-1)} className="h-7 w-7 p-0" data-testid="reservation-prev-month">
                      <ChevronLeft className="w-4 h-4" />
                    </Button>
                    <div className="text-center min-w-[108px]">
                      <p className="text-[13px] font-semibold text-slate-800" data-testid="reservation-month-label">{MONTHS[reservationMonth]} {reservationYear}</p>
                      {!isCurrentReservationMonth && (
                        <button onClick={goToCurrentReservationMonth} className="text-[10px] text-[#176B91] hover:underline" data-testid="reservation-current-month">Bu Aya Dön</button>
                      )}
                    </div>
                    <Button variant="ghost" size="sm" onClick={() => changeReservationMonth(1)} className="h-7 w-7 p-0" data-testid="reservation-next-month">
                      <ChevronRight className="w-4 h-4" />
                    </Button>
                  </div>
                  <Button variant="outline" size="sm" className="h-9" onClick={exportReservationsToExcel} data-testid="reservations-excel-btn">
                    <Download className="w-4 h-4 mr-1.5" /> Excel
                  </Button>
                  <Button size="sm" className="h-9 bg-[#0B172A] hover:bg-[#13233C]" onClick={() => setShowNewReservationDialog(true)} data-testid="new-reservation-btn">
                    <Plus className="w-4 h-4 mr-1.5" /> Yeni Rezervasyon
                  </Button>
                </>
              }
            >
              <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-2">
                <div>
                  <Label className="text-[11px] text-slate-500">Salon</Label>
                  <Select value={reservationFilters.salon_id} onValueChange={(value) => setReservationFilters({...reservationFilters, salon_id: value})}>
                    <SelectTrigger className="h-9" data-testid="reservation-filter-salon"><SelectValue placeholder="Tümü" /></SelectTrigger>
                    <SelectContent>
                      <SelectItem value="all">Tüm Salonlar</SelectItem>
                      {salons.map((salon) => (<SelectItem key={salon.id} value={salon.id}>{salon.name}</SelectItem>))}
                    </SelectContent>
                  </Select>
                </div>
                <div>
                  <Label className="text-[11px] text-slate-500">Hakem</Label>
                  <Select value={reservationFilters.referee_id} onValueChange={(value) => setReservationFilters({...reservationFilters, referee_id: value})}>
                    <SelectTrigger className="h-9" data-testid="reservation-filter-referee"><SelectValue placeholder="Tümü" /></SelectTrigger>
                    <SelectContent>
                      <SelectItem value="all">Tüm Hakemler</SelectItem>
                      <SelectItem value="none">Hakemsiz</SelectItem>
                      {referees.map((referee) => (<SelectItem key={referee.id} value={referee.id}>{referee.name}</SelectItem>))}
                    </SelectContent>
                  </Select>
                </div>
                <div>
                  <Label className="text-[11px] text-slate-500">Ödeme Durumu</Label>
                  <Select value={reservationFilters.payment_status} onValueChange={(value) => setReservationFilters({...reservationFilters, payment_status: value})}>
                    <SelectTrigger className="h-9" data-testid="reservation-filter-payment"><SelectValue placeholder="Tümü" /></SelectTrigger>
                    <SelectContent>
                      <SelectItem value="all">Tümü</SelectItem>
                      <SelectItem value="odendi">Ödendi</SelectItem>
                      <SelectItem value="odenmedi">Ödenmedi</SelectItem>
                      <SelectItem value="overdue">Vadesi Geçmiş (Faturalı)</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                <div>
                  <Label className="text-[11px] text-slate-500">Fatura</Label>
                  <Select value={reservationFilters.invoice_status} onValueChange={(value) => setReservationFilters({...reservationFilters, invoice_status: value})}>
                    <SelectTrigger className="h-9" data-testid="reservation-filter-invoice"><SelectValue placeholder="Tümü" /></SelectTrigger>
                    <SelectContent>
                      <SelectItem value="all">Tümü</SelectItem>
                      <SelectItem value="issued">Fatura Kesildi</SelectItem>
                      <SelectItem value="not_issued">Fatura Kesilmedi</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                <div>
                  <Label className="text-[11px] text-slate-500">Başlangıç</Label>
                  <Input type="date" value={reservationFilters.date_from} className="h-9"
                    onChange={(e) => setReservationFilters({...reservationFilters, date_from: e.target.value})}
                    data-testid="reservation-filter-date-from" />
                </div>
                <div className="flex items-end gap-2">
                  <div className="flex-1">
                    <Label className="text-[11px] text-slate-500">Bitiş</Label>
                    <Input type="date" value={reservationFilters.date_to} className="h-9"
                      onChange={(e) => setReservationFilters({...reservationFilters, date_to: e.target.value})}
                      data-testid="reservation-filter-date-to" />
                  </div>
                  <Button variant="outline" size="sm" className="h-9"
                    onClick={() => setReservationFilters({ salon_id: 'all', referee_id: 'all', payment_status: 'all', invoice_status: 'all', date_from: '', date_to: '' })}
                    data-testid="reservation-filter-clear">
                    <X className="w-3.5 h-3.5" />
                  </Button>
                </div>
              </div>
            </PageHeader>

            {/* ===== KPI kartları (filtreye göre) ===== */}
            {(() => {
              const filtered = getFilteredReservations();
              const paid = filtered.filter(r => r.payment_status === 'odendi');
              const unpaid = filtered.filter(r => r.payment_status === 'odenmedi');
              const totalAmount = filtered.reduce((s, r) => s + (r.total_amount || 0), 0);
              const netTotal = filtered.reduce((s, r) => s + calcReservationNet(r), 0);
              const invoiced = filtered.filter(r => r.invoice_issued);
              return (
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
                  <StatCard icon={Clock} tone="sky" testid="res-kpi-count" label="Rezervasyon"
                    value={filtered.length} sub={`${reservations.length} kayıttan filtreli`} />
                  <StatCard icon={TrendingUp} tone="indigo" testid="res-kpi-total" label="Dönem Cirosu"
                    value={formatTL(totalAmount)} sub={`Net ${formatTL(netTotal)} (kapora/gider sonrası)`} />
                  <StatCard icon={CheckCircle} tone="emerald" testid="res-kpi-paid" label="Ödenmiş"
                    value={formatTL(paid.reduce((s, r) => s + (r.total_amount || 0), 0))} sub={`${paid.length} rezervasyon`} />
                  <StatCard icon={AlertCircle} tone="rose" testid="res-kpi-unpaid" label="Bekleyen"
                    value={formatTL(unpaid.reduce((s, r) => s + (r.total_amount || 0), 0))}
                    sub={`${unpaid.length} rezervasyon · ${invoiced.length} faturalı`} />
                </div>
              );
            })()}

            {/* Yeni Rezervasyon (tek / toplu) — kurumsal dialog */}
            <NewReservationDialog
              open={showNewReservationDialog}
              onOpenChange={setShowNewReservationDialog}
              salons={salons}
              customers={customers}
              referees={referees}
              prefill={newReservation}
              onCreated={() => {
                refreshReservationTab();
                fetchTodayReservations();
                fetchAnalytics();
                fetchCustomers();
                fetchReferees();
                fetchRefereesTotalBalance();
              }}
            />

            {/* ===== Rezervasyon tablosu (kurumsal ProTable) ===== */}
            {(() => {
              const rows = getFilteredReservations();
              const resExpenseTotal = (r) => allReservationExpenses
                .filter(e => e.reservation_id === r.id)
                .reduce((sum, e) => sum + (e.amount || 0), 0);
              const columns = [
                { key: 'date', label: 'Tarih', width: 104, sortable: true,
                  value: (r) => r.date,
                  render: (r) => <span className="text-slate-700 whitespace-nowrap">{formatDateTR(r.date)}</span> },
                { key: 'time', label: 'Saat', width: 104, sortable: true,
                  value: (r) => r.start_time || '',
                  render: (r) => <span className="tabular-nums text-slate-600 whitespace-nowrap">{r.start_time?.slice(0, 5)} – {r.end_time?.slice(0, 5)}</span> },
                { key: 'customer', label: 'Müşteri', sortable: true,
                  value: (r) => getCustomerName(r.customer_id),
                  render: (r) => (
                    <div className="min-w-0">
                      <p className="font-semibold text-slate-800 truncate max-w-[200px]">{getCustomerName(r.customer_id)}</p>
                      {r.notes && <p className="text-[11px] text-slate-500 truncate max-w-[200px]">{r.notes}</p>}
                    </div>
                  ) },
                { key: 'salon', label: 'Salon', sortable: true,
                  value: (r) => getSalonName(r.salon_id),
                  render: (r) => <span className="text-[12px] text-slate-600">{getSalonName(r.salon_id)}</span> },
                { key: 'referee', label: 'Hakem', width: 130, sortable: true,
                  value: (r) => (referees.find(x => x.id === r.referee_id)?.name || ''),
                  render: (r) => {
                    const ref = referees.find(x => x.id === r.referee_id);
                    return ref
                      ? <span className="text-[12px] text-[#176B91] font-medium">{ref.name}</span>
                      : <span className="text-[12px] text-slate-400">-</span>;
                  } },
                { key: 'total', label: 'Tutar', width: 120, align: 'right', sortable: true,
                  value: (r) => r.total_amount || 0,
                  render: (r) => <span className="font-semibold text-slate-900 tabular-nums">{formatTL(r.total_amount)}</span> },
                { key: 'referee_fee', label: 'Hakem Ücreti', width: 118, align: 'right', sortable: true,
                  value: (r) => r.referee_fee || 0,
                  render: (r) => (r.referee_fee
                    ? <span className="text-amber-700 tabular-nums">{formatTL(r.referee_fee)}</span>
                    : <span className="text-slate-400">-</span>) },
                { key: 'net', label: 'Net Tutar', width: 140, align: 'right', sortable: true,
                  value: (r) => calcReservationNet(r),
                  render: (r) => {
                    const net = calcReservationNet(r);
                    const kapora = getReservationKapora(r);
                    const exp = resExpenseTotal(r);
                    return (
                      <div className="text-right">
                        <span className={`font-bold tabular-nums ${net < 0 ? 'text-rose-700' : 'text-emerald-700'}`}>{formatTL(net)}</span>
                        {(kapora > 0 || exp > 0) && (
                          <p className="text-[10px] leading-tight text-slate-500">
                            {kapora > 0 && <span className="block">kapora −{formatTL(kapora)}</span>}
                            {exp > 0 && <span className="block text-rose-600">gider −{formatTL(exp)}</span>}
                          </p>
                        )}
                      </div>
                    );
                  } },
                { key: 'payment', label: 'Ödeme', width: 180, hideable: false,
                  render: (r) => (
                    <div onClick={(e) => e.stopPropagation()}>
                      <Select value={r.payment_status} onValueChange={(value) => handlePaymentStatusChange(r, value)}>
                        <SelectTrigger className="w-[164px] h-8 text-[12px]" data-testid={`payment-status-${r.id}`}>
                          <SelectValue />
                        </SelectTrigger>
                        <SelectContent>
                          <SelectItem value="odendi">
                            <span className="flex items-center gap-1">
                              <CheckCircle2 className="w-3 h-3 text-emerald-600" />
                              {reservationHasReferee(r) ? 'Hakeme Ödendi' : 'Ödendi'}
                            </span>
                          </SelectItem>
                          <SelectItem value="odenmedi">
                            <span className="flex items-center gap-1">
                              <XCircle className="w-3 h-3 text-rose-600" />
                              {reservationHasReferee(r) ? 'Hakeme Ödenmedi' : 'Ödenmedi'}
                            </span>
                          </SelectItem>
                        </SelectContent>
                      </Select>
                    </div>
                  ) },
                { key: 'invoice', label: 'Fatura', width: 160,
                  render: (r) => (
                    <div onClick={(e) => e.stopPropagation()}>
                      <button
                        onClick={() => updateInvoiceStatus(r.id, !r.invoice_issued)}
                        className={`inline-flex items-center gap-1 px-2 py-1 rounded-md text-[11px] font-medium transition-colors ${
                          r.invoice_issued
                            ? 'bg-indigo-100 text-indigo-700 hover:bg-indigo-200'
                            : 'bg-slate-100 text-slate-500 hover:bg-slate-200'
                        }`}
                        data-testid={`invoice-toggle-${r.id}`}
                      >
                        <FileText className="w-3 h-3" />
                        {r.invoice_issued ? 'Faturalı +KDV' : 'Kesilmedi'}
                      </button>
                      {r.invoice_issued && (
                        <p className="text-[10px] text-indigo-700 mt-1" data-testid={`vat-info-${r.id}`}>
                          Matrah {formatTL(r.base_amount ?? r.total_amount ?? 0)} + KDV {formatTL(r.vat_amount || 0)}
                        </p>
                      )}
                      {r.invoice_issued && r.invoice_due_date && (() => {
                        const today = new Date(Date.now() + 3 * 3600 * 1000).toISOString().slice(0, 10);
                        const due = String(r.invoice_due_date).slice(0, 10);
                        const overdue = r.payment_status !== 'odendi' && due < today;
                        return (
                          <p className={`text-[10px] mt-0.5 font-medium ${overdue ? 'text-rose-700' : 'text-slate-500'}`}
                            data-testid={`invoice-due-${r.id}`}>
                            Vade {formatDateTR(due)}{overdue ? ' · Vadesi Geçti' : ''}
                          </p>
                        );
                      })()}
                    </div>
                  ) },
                { key: 'actions', label: 'İşlemler', width: 96, align: 'center', hideable: false,
                  render: (r) => (
                    <div className="flex items-center justify-center gap-1" onClick={(e) => e.stopPropagation()}>
                      <Button size="sm" variant="ghost" className="h-8 w-8 p-0 text-[#176B91] hover:bg-sky-50"
                        data-testid={`reservation-edit-${r.id}`}
                        onClick={() => {
                          // Faturalı maçta tutar alanı KDV'siz matrahı gösterir
                          setEditingReservation({
                            ...r,
                            total_amount: r.invoice_issued ? (r.base_amount ?? r.total_amount) : r.total_amount,
                          });
                          setShowEditReservationModal(true);
                        }}>
                        <Edit className="w-4 h-4" />
                      </Button>
                      <Button size="sm" variant="ghost" className="h-8 w-8 p-0 text-rose-600 hover:bg-rose-50"
                        data-testid={`reservation-delete-${r.id}`}
                        onClick={() => handleDeleteReservation(r.id)}>
                        <Trash2 className="w-4 h-4" />
                      </Button>
                    </div>
                  ) },
              ];
              return (
                <ProTable
                  testid="reservations-table"
                  columns={columns}
                  rows={rows}
                  rowKey={(r) => r.id}
                  onRowClick={(r) => openReservationDetail(r)}
                  initialSort={{ key: 'date', dir: 'desc' }}
                  defaultPageSize={50}
                  emptyText="Filtrelere uygun rezervasyon bulunamadı"
                  emptyIcon={Clock}
                  footer={(visible) => (
                    <tr>
                      {visible.map(c => (
                        <td key={c.key} className={`px-3 py-2 text-[12px] font-bold ${c.align === 'right' ? 'text-right' : ''}`}>
                          {c.key === 'date' ? `${rows.length} kayıt`
                            : c.key === 'total' ? formatTL(rows.reduce((s, r) => s + (r.total_amount || 0), 0))
                            : c.key === 'referee_fee' ? formatTL(rows.reduce((s, r) => s + (r.referee_fee || 0), 0))
                            : c.key === 'net' ? formatTL(rows.reduce((s, r) => s + calcReservationNet(r), 0))
                            : ''}
                        </td>
                      ))}
                    </tr>
                  )}
                />
              );
            })()}
          </TabsContent>

          {/* Customers Tab */}
          {/* Customers Tab - Corporate redesign */}
          <TabsContent value="customers" className="space-y-4">
            <CustomersTab
              customers={customers}
              reservations={reservations}
              salons={salons}
              fetchCustomers={fetchCustomers}
              fetchReservations={fetchReservations}
              fetchIncomes={fetchIncomes}
              fetchExpenses={fetchExpenses}
              fetchRefereesTotalBalance={fetchRefereesTotalBalance}
              focusCustomerId={focusCustomerId}
              onFocusHandled={() => setFocusCustomerId(null)}
            />
          </TabsContent>

          {/* Salons Tab */}
          <TabsContent value="salons" className="space-y-6">
            <PageHeader
              icon={MapPin}
              title="Salon ve Tesis Yönetimi"
              description={`${getFilteredSalons().length} / ${salons.length} salon gösteriliyor`}
              testid="salons-page-header"
              actions={
              <Dialog>
                <DialogTrigger asChild>
                  <Button className="h-9 bg-[#0B172A] hover:bg-[#13233C]" data-testid="add-salon-btn">
                    <Plus className="w-4 h-4 mr-2" />
                    Yeni Salon Ekle
                  </Button>
                </DialogTrigger>
                <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto">
                  <DialogHeader>
                    <DialogTitle>Yeni Salon Ekle</DialogTitle>
                    <DialogDescription>
                      Salon bilgilerini girin
                    </DialogDescription>
                  </DialogHeader>
                  <form onSubmit={createSalon} className="space-y-4">
                    <div className="grid grid-cols-2 gap-4">
                      <div className="col-span-2">
                        <Label htmlFor="name">Salon Adı *</Label>
                        <Input
                          id="name"
                          value={newSalon.name}
                          onChange={(e) => setNewSalon({...newSalon, name: e.target.value})}
                          placeholder="Örn: Ana Salon"
                          required
                        />
                      </div>
                      <div className="col-span-2">
                        <Label htmlFor="location">Konum / Adres</Label>
                        <Input
                          id="location"
                          value={newSalon.location}
                          onChange={(e) => setNewSalon({...newSalon, location: e.target.value})}
                          placeholder="Örn: Kadıköy, İstanbul"
                        />
                      </div>
                      <div>
                        <Label htmlFor="capacity">Kapasite (Kişi)</Label>
                        <Input
                          id="capacity"
                          type="number"
                          value={newSalon.capacity}
                          onChange={(e) => setNewSalon({...newSalon, capacity: e.target.value})}
                          placeholder="Örn: 50"
                        />
                      </div>
                      <div>
                        <Label htmlFor="phone">Telefon</Label>
                        <Input
                          id="phone"
                          value={newSalon.phone}
                          onChange={(e) => setNewSalon({...newSalon, phone: e.target.value})}
                          placeholder="05xx xxx xxxx"
                        />
                      </div>
                    </div>
                    
                    <div className="border-t pt-4">
                      <p className="text-[12px] font-semibold text-slate-500 uppercase tracking-wide mb-3">Ücretlendirme</p>
                      <div className="grid grid-cols-3 gap-3">
                        <div>
                          <Label htmlFor="hourly_rate_1h">1 Saat *</Label>
                          <Input
                            id="hourly_rate_1h"
                            type="number"
                            step="0.01"
                            value={newSalon.hourly_rate_1h}
                            onChange={(e) => setNewSalon({...newSalon, hourly_rate_1h: e.target.value})}
                            placeholder="₺"
                            required
                          />
                        </div>
                        <div>
                          <Label htmlFor="hourly_rate_1_5h">1.5 Saat *</Label>
                          <Input
                            id="hourly_rate_1_5h"
                            type="number"
                            step="0.01"
                            value={newSalon.hourly_rate_1_5h}
                            onChange={(e) => setNewSalon({...newSalon, hourly_rate_1_5h: e.target.value})}
                            placeholder="₺"
                            required
                          />
                        </div>
                        <div>
                          <Label htmlFor="hourly_rate_2h">2 Saat *</Label>
                          <Input
                            id="hourly_rate_2h"
                            type="number"
                            step="0.01"
                            value={newSalon.hourly_rate_2h}
                            onChange={(e) => setNewSalon({...newSalon, hourly_rate_2h: e.target.value})}
                            placeholder="₺"
                            required
                          />
                        </div>
                      </div>
                    </div>
                    
                    <div>
                      <Label htmlFor="description">Açıklama</Label>
                      <Textarea
                        id="description"
                        value={newSalon.description}
                        onChange={(e) => setNewSalon({...newSalon, description: e.target.value})}
                        placeholder="Salon hakkında ek bilgiler..."
                      />
                    </div>
                    
                    <Button type="submit" className="w-full bg-[#0B172A] hover:bg-[#13233C]">
                      Salon Ekle
                    </Button>
                  </form>
                </DialogContent>
              </Dialog>
              }
            >
              <div className="flex flex-wrap items-center gap-2">
                <div className="relative flex-1 min-w-[240px]">
                  <Search className="w-4 h-4 absolute left-3 top-2.5 text-slate-400" />
                  <Input
                    placeholder="Salon adı veya konum ara..."
                    value={salonFilters.search}
                    onChange={(e) => setSalonFilters({...salonFilters, search: e.target.value})}
                    className="pl-9 h-9 bg-[#F8FAFC]"
                    data-testid="salon-search"
                  />
                </div>
                {salonFilters.search && (
                  <Button variant="ghost" size="sm" className="h-9 text-slate-500" onClick={() => setSalonFilters({ search: '' })} data-testid="salon-clear-filters">
                    <X className="w-4 h-4 mr-1" /> Temizle
                  </Button>
                )}
              </div>
            </PageHeader>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-3" data-testid="salon-kpis">
              <StatCard icon={MapPin} tone="indigo" testid="kpi-salon-total" label="Toplam Salon" value={getSalonStats().total} sub="kayıtlı tesis" />
              <StatCard icon={Users} tone="sky" testid="kpi-salon-capacity" label="Toplam Kapasite" value={`${getSalonStats().totalCapacity || '-'} kişi`} sub="tüm salonlar" />
              <StatCard icon={DollarSign} tone="emerald" testid="kpi-salon-avg-rate" label="Ort. Saatlik Ücret" value={`₺${getSalonStats().avgRate}`} sub="1 saat bazında" />
              <StatCard icon={CalendarDays} tone="amber" testid="kpi-salon-reservations" label="Toplam Rezervasyon" value={getSalonStats().totalReservations} sub="tüm zamanlar" />
            </div>

            {/* Salon Kartları */}
            {(() => {
              // Haftalık doluluk ısı şeridi: bu haftanın (Pzt-Paz) dolu saatleri / açık kapasite
              const now = new Date();
              const monday = new Date(now);
              monday.setDate(now.getDate() - ((now.getDay() + 6) % 7));
              const wkStart = monday.toISOString().slice(0, 10);
              const wkEnd = new Date(monday.getTime() + 6 * 864e5).toISOString().slice(0, 10);
              const OPEN_HOURS_PER_WEEK = 7 * 15; // varsayılan: günlük 09:00–24:00
              const dayOpenHours = (h) => {
                if (!h || h.closed) return 0;
                const [oh, om] = String(h.open || '09:00').split(':').map(Number);
                let [ch, cm] = String(h.close || '00:00').split(':').map(Number);
                let mins = (ch * 60 + (cm || 0)) - (oh * 60 + (om || 0));
                if (mins <= 0) mins += 24 * 60;
                return mins / 60;
              };
              const openHoursOfWeek = (salon) => {
                const wh = salon.working_hours;
                if (!Array.isArray(wh) || wh.length !== 7) return OPEN_HOURS_PER_WEEK;
                const total = wh.reduce((s, h) => s + dayOpenHours(h), 0);
                return total > 0 ? total : OPEN_HOURS_PER_WEEK;
              };
              const hoursOf = (r) => {
                const [sh, sm] = (r.start_time || '0:0').split(':').map(Number);
                const [eh, em] = (r.end_time || '0:0').split(':').map(Number);
                const diff = (eh * 60 + (em || 0)) - (sh * 60 + (sm || 0));
                return diff > 0 ? diff / 60 : 0;
              };
              const weekRes = reservations.filter(r => r.date >= wkStart && r.date <= wkEnd);
              return (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
              {getFilteredSalons().map((salon) => {
                const salonReservations = reservations.filter(r => r.salon_id === salon.id).length;
                const todaySalonReservations = todayReservations.filter(r => r.salon_id === salon.id).length;
                const salonWeek = weekRes.filter(r => r.salon_id === salon.id);
                const busyHours = Math.round(salonWeek.reduce((s, r) => s + hoursOf(r), 0) * 10) / 10;
                const occupancy = Math.min(Math.round(busyHours / openHoursOfWeek(salon) * 100), 100);
                const occTone = occupancy >= 50 ? 'bg-emerald-500' : occupancy >= 25 ? 'bg-amber-500' : occupancy > 0 ? 'bg-rose-500' : 'bg-slate-300';
                const occText = occupancy >= 50 ? 'text-emerald-700' : occupancy >= 25 ? 'text-amber-700' : occupancy > 0 ? 'text-rose-700' : 'text-slate-500';

                return (
                  <div key={salon.id}
                    className="bg-white rounded-xl border border-[#E2E8F0] shadow-sm hover:shadow-md hover:border-slate-300 transition-all overflow-hidden"
                    data-testid={`salon-card-${salon.id}`}>
                    {/* Haftalık doluluk ısı şeridi */}
                    <div className="h-1.5 bg-slate-100" title={`Bu hafta doluluk %${occupancy}`} data-testid={`salon-heat-${salon.id}`}>
                      <div className={`h-full ${occTone} transition-all`} style={{ width: `${occupancy}%` }}></div>
                    </div>
                    <div className="p-4 space-y-3">
                      <div className="flex items-start justify-between gap-2">
                        <div className="flex items-center gap-2.5 min-w-0">
                          <div className="w-10 h-10 rounded-xl bg-[#0B172A] flex items-center justify-center text-white font-bold shrink-0">
                            {salon.name?.charAt(0)?.toUpperCase()}
                          </div>
                          <div className="min-w-0">
                            <p className="font-bold text-slate-900 text-[15px] leading-tight truncate">{salon.name}</p>
                            <p className="text-[11px] text-slate-500 truncate">{salon.sports?.join(', ') || 'Voleybol, Basketbol'}</p>
                          </div>
                        </div>
                        <div className="flex flex-col items-end gap-1 shrink-0">
                          <Badge className={`text-[10px] ${salon.active ? 'bg-emerald-100 text-emerald-800' : 'bg-rose-100 text-rose-800'} hover:bg-current/10`}>
                            {salon.active ? 'Aktif' : 'Pasif'}
                          </Badge>
                          {salon.exclude_from_kasa && (
                            <Badge className="text-[10px] bg-amber-100 text-amber-800 hover:bg-amber-100">Kasaya yansımaz</Badge>
                          )}
                        </div>
                      </div>

                      <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-[12px] text-slate-600">
                        {salon.location && (
                          <span className="inline-flex items-center gap-1.5 min-w-0">
                            <MapPin className="w-3.5 h-3.5 text-slate-400 shrink-0" />
                            <span className="truncate max-w-[200px]">{salon.location}</span>
                          </span>
                        )}
                        {salon.capacity && (
                          <span className="inline-flex items-center gap-1.5">
                            <Users className="w-3.5 h-3.5 text-slate-400" />{salon.capacity} kişi
                          </span>
                        )}
                        {salon.phone && (
                          <span className="inline-flex items-center gap-1.5">
                            <Phone className="w-3.5 h-3.5 text-slate-400" />{salon.phone}
                          </span>
                        )}
                      </div>

                      <div className="rounded-lg border border-[#E2E8F0] bg-[#F8FAFC] p-2.5">
                        <p className="text-[10px] font-semibold text-slate-500 uppercase tracking-wide mb-1.5">Ücret Tarifesi</p>
                        <div className="grid grid-cols-3 gap-2 text-center">
                          {[['1 Saat', salon.hourly_rate_1h], ['1.5 Saat', salon.hourly_rate_1_5h], ['2 Saat', salon.hourly_rate_2h]].map(([lbl, val]) => (
                            <div key={lbl}>
                              <p className="text-[15px] font-bold text-slate-900 tabular-nums">{formatTL(val)}</p>
                              <p className="text-[10px] text-slate-500">{lbl}</p>
                            </div>
                          ))}
                        </div>
                      </div>

                      <div className="rounded-lg border border-[#E2E8F0] bg-[#F8FAFC] p-2.5" data-testid={`salon-hours-${salon.id}`}>
                        <div className="flex items-center justify-between mb-1.5">
                          <p className="text-[10px] font-semibold text-slate-500 uppercase tracking-wide">Çalışma Saatleri</p>
                          <button
                            className="text-[11px] font-semibold text-[#176B91] hover:underline"
                            data-testid={`salon-hours-edit-${salon.id}`}
                            onClick={() => { setSalonHoursTarget(salon); setShowSalonHoursModal(true); }}
                          >
                            Düzenle
                          </button>
                        </div>
                        <div className="grid grid-cols-7 gap-1 text-center">
                          {['Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt', 'Paz'].map((d, i) => {
                            const h = Array.isArray(salon.working_hours) ? salon.working_hours[i] : null;
                            const closed = h?.closed;
                            return (
                              <div key={d} className={`rounded-md px-0.5 py-1 ${closed ? 'bg-rose-50' : 'bg-white border border-[#E6EDF3]'}`}>
                                <p className="text-[9px] font-semibold text-slate-500">{d}</p>
                                <p className={`text-[9px] leading-tight tabular-nums ${closed ? 'text-rose-600' : 'text-slate-700'}`}>
                                  {closed ? 'Kapalı' : (
                                    <>
                                      {String(h?.open || '09:00').slice(0, 5)}<br />
                                      {String(h?.close || '00:00').slice(0, 5) === '00:00' ? '24:00' : String(h?.close).slice(0, 5)}
                                    </>
                                  )}
                                </p>
                              </div>
                            );
                          })}
                        </div>
                      </div>

                      <div className="flex items-center justify-between pt-1">
                        <span className="inline-flex items-center gap-1.5 text-[12px] text-slate-600">
                          <CalendarDays className="w-3.5 h-3.5 text-[#176B91]" />
                          {salonReservations} rezervasyon
                        </span>
                        {todaySalonReservations > 0 && (
                          <Badge className="text-[10px] bg-sky-100 text-[#176B91] hover:bg-sky-100">Bugün: {todaySalonReservations}</Badge>
                        )}
                      </div>

                      <div className="flex items-center justify-between rounded-lg border border-[#E2E8F0] bg-[#F8FAFC] px-2.5 py-2">
                        <div>
                          <p className="text-[10px] font-semibold text-slate-500 uppercase tracking-wide">Bu Hafta Doluluk</p>
                          <p className="text-[11px] text-slate-500">{busyHours} saat dolu · {salonWeek.length} rezervasyon</p>
                        </div>
                        <p className={`text-xl font-bold tabular-nums ${occText}`} data-testid={`salon-occupancy-${salon.id}`}>%{occupancy}</p>
                      </div>

                      {salon.description && (
                        <p className="text-[11px] text-slate-500 border-l-2 border-slate-200 pl-2">{salon.description}</p>
                      )}

                      <div className="flex items-center gap-2 pt-2 border-t border-[#E2E8F0]">
                        <Button
                          size="sm"
                          variant="outline"
                          className="flex-1 h-8 text-[12px] text-[#176B91] hover:bg-sky-50"
                          data-testid={`salon-edit-${salon.id}`}
                          onClick={() => {
                            setEditingSalon({...salon});
                            setShowEditSalonModal(true);
                          }}
                        >
                          <Edit className="w-3.5 h-3.5 mr-1" /> Düzenle
                        </Button>
                        <Button
                          size="sm"
                          variant="outline"
                          className="h-8 text-rose-600 hover:bg-rose-50"
                          data-testid={`salon-delete-${salon.id}`}
                          onClick={() => handleDeleteSalon(salon.id)}
                        >
                          <Trash2 className="w-3.5 h-3.5" />
                        </Button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
              );
            })()}

            
            {getFilteredSalons().length === 0 && (
              <div className="text-center py-12">
                <MapPin className="w-12 h-12 mx-auto text-slate-300 mb-3" />
                <p className="text-slate-500">Filtrelere uygun salon bulunamadı</p>
              </div>
            )}

            <SalonHoursModal
              open={showSalonHoursModal}
              onOpenChange={setShowSalonHoursModal}
              salon={salonHoursTarget}
              onSaved={fetchSalons}
            />
          </TabsContent>

          {/* Saha Dolum Raporu */}
          <TabsContent value="occupancy" className="space-y-4">
            <OccupancyTab salons={salons} />
          </TabsContent>

          {/* Financials Tab (Refactored) */}
          <TabsContent value="financials" className="space-y-6">
            <FinancialsTab
              incomes={incomes}
              expenses={expenses}
              customers={customers}
              reservations={reservations}
              categories={categories}
              refereesTotalBalance={refereesTotalBalance}
              fetchIncomes={fetchIncomes}
              fetchExpenses={fetchExpenses}
              fetchCategories={fetchCategories}
              fetchAnalytics={fetchAnalytics}
              fetchRefereesTotalBalance={fetchRefereesTotalBalance}
              initialSubTab={financialsSubTab}
              quickAction={financialsQuickAction}
              onQuickActionConsumed={() => setFinancialsQuickAction(null)}
            />
          </TabsContent>

          {/* Kasalar — hesap yönetimi + detaylı işlem listesi */}
          <TabsContent value="cash-accounts" className="space-y-4">
            <CashAccountsTab canManage={!isPersonnel || personnelPerms.includes('kasa_hesap')} />
          </TabsContent>

          {/* Gün Sonu Kontrol Merkezi */}
          <TabsContent value="closing" className="space-y-4">
            <ClosingTab onNavigate={(tab) => setActiveTab(tab)} />
          </TabsContent>

          {/* Hatırlatmalar — personel kendi görev hatırlatmalarını yönetir */}
          <TabsContent value="reminders" className="space-y-4">
            <RemindersTab personnelList={personnelList} />
          </TabsContent>

          {/* Referees Tab - Hakemler (Refactored) */}
          <TabsContent value="referees" className="space-y-4">
            <RefereesTab
              referees={referees}
              reservations={reservations}
              salons={salons}
              customers={customers}
              allReservationExpenses={allReservationExpenses}
              refereesTotalBalance={refereesTotalBalance}
              fetchReferees={fetchReferees}
              fetchRefereesTotalBalance={fetchRefereesTotalBalance}
              fetchReservations={fetchReservations}
              fetchIncomes={fetchIncomes}
              fetchExpenses={fetchExpenses}
              focusRefereeId={focusRefereeId}
              onFocusHandled={() => setFocusRefereeId(null)}
              onOpenReservationDetail={openReservationDetail}
            />
          </TabsContent>

          <TabsContent value="notifications" className="space-y-4">
            <NotificationsTab />
          </TabsContent>

          <TabsContent value="staff" className="space-y-4 md:space-y-6">
            <PersonnelTab
              personnelList={personnelList}
              fetchPersonnel={fetchPersonnel}
              isAdmin={!isPersonnel}
            />
          </TabsContent>

          {/* Personel Düzenleme Modal */}
          <Dialog open={showEditPersonnelModal} onOpenChange={setShowEditPersonnelModal}>
            <DialogContent className="max-w-md">
              <DialogHeader>
                <DialogTitle>Personel Düzenle</DialogTitle>
              </DialogHeader>
              {editingPersonnel && (
                <form onSubmit={handleUpdatePersonnel} className="space-y-4">
                  <div>
                    <Label>Ad Soyad *</Label>
                    <Input
                      value={editingPersonnel.name}
                      onChange={(e) => setEditingPersonnel({...editingPersonnel, name: e.target.value})}
                      required
                    />
                  </div>
                  <div>
                    <Label>Telefon</Label>
                    <Input
                      value={editingPersonnel.phone || ''}
                      onChange={(e) => setEditingPersonnel({...editingPersonnel, phone: e.target.value})}
                    />
                  </div>
                  <div>
                    <Label>E-posta</Label>
                    <Input
                      type="email"
                      value={editingPersonnel.email || ''}
                      onChange={(e) => setEditingPersonnel({...editingPersonnel, email: e.target.value})}
                    />
                  </div>
                  <div>
                    <Label>Pozisyon</Label>
                    <Input
                      value={editingPersonnel.position || ''}
                      onChange={(e) => setEditingPersonnel({...editingPersonnel, position: e.target.value})}
                    />
                  </div>
                  <div>
                    <Label>Aylık Maaş (₺)</Label>
                    <Input
                      type="number"
                      step="0.01"
                      value={editingPersonnel.salary || ''}
                      onChange={(e) => setEditingPersonnel({...editingPersonnel, salary: parseFloat(e.target.value) || 0})}
                      placeholder="Örn: 15000"
                    />
                  </div>
                  <div className="border-t pt-4">
                    <p className="text-sm font-medium text-slate-700 mb-3">Giriş Bilgileri</p>
                    <div className="space-y-3">
                      <div>
                        <Label>Kullanıcı Adı *</Label>
                        <Input
                          value={editingPersonnel.username}
                          onChange={(e) => setEditingPersonnel({...editingPersonnel, username: e.target.value})}
                          required
                        />
                      </div>
                      <div>
                        <Label>Yeni Şifre</Label>
                        <Input
                          type="password"
                          value={editingPersonnel.password || ''}
                          onChange={(e) => setEditingPersonnel({...editingPersonnel, password: e.target.value})}
                          placeholder="Değiştirmek için doldurun"
                        />
                        <p className="text-xs text-slate-500 mt-1">Boş bırakırsanız mevcut şifre korunur</p>
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    <input
                      type="checkbox"
                      id="activeStatus"
                      checked={editingPersonnel.active !== false}
                      onChange={(e) => setEditingPersonnel({...editingPersonnel, active: e.target.checked})}
                    />
                    <Label htmlFor="activeStatus">Aktif</Label>
                  </div>
                  <Button type="submit" className="w-full">Güncelle</Button>
                </form>
              )}
            </DialogContent>
          </Dialog>

          {/* Personel Yetki Yönetimi Modal */}
          <Dialog open={showPermissionsModal} onOpenChange={setShowPermissionsModal}>
            <DialogContent className="max-w-lg">
              <DialogHeader>
                <DialogTitle>🔐 Yetki Yönetimi</DialogTitle>
                <DialogDescription>
                  {selectedPersonnelForPermissions?.name} için erişim yetkilerini düzenleyin
                </DialogDescription>
              </DialogHeader>
              {selectedPersonnelForPermissions && (
                <div className="space-y-4">
                  <div className="bg-blue-50 p-3 rounded-lg border border-blue-200">
                    <p className="text-sm text-blue-800">
                      <strong>Personel:</strong> {selectedPersonnelForPermissions.name}
                    </p>
                    <p className="text-xs text-blue-600 mt-1">
                      Kullanıcı Adı: {selectedPersonnelForPermissions.username}
                    </p>
                  </div>
                  
                  <div className="space-y-3">
                    <p className="text-sm font-medium text-slate-700">Erişebileceği Sayfalar:</p>
                    <div className="grid grid-cols-2 gap-2">
                      {ALL_PERMISSIONS.map((perm) => (
                        <div 
                          key={perm.id}
                          className={`flex items-center gap-2 p-3 rounded-lg border cursor-pointer transition-all ${
                            (selectedPersonnelForPermissions.permissions || []).includes(perm.id)
                              ? 'bg-green-50 border-green-300 text-green-800'
                              : 'bg-slate-50 border-slate-200 text-slate-600 hover:bg-slate-100'
                          }`}
                          onClick={() => {
                            const currentPerms = selectedPersonnelForPermissions.permissions || [];
                            const newPerms = currentPerms.includes(perm.id)
                              ? currentPerms.filter(p => p !== perm.id)
                              : [...currentPerms, perm.id];
                            setSelectedPersonnelForPermissions({
                              ...selectedPersonnelForPermissions,
                              permissions: newPerms
                            });
                          }}
                        >
                          <span className="text-lg">{perm.icon}</span>
                          <span className="text-sm font-medium">{perm.label}</span>
                          {(selectedPersonnelForPermissions.permissions || []).includes(perm.id) && (
                            <span className="ml-auto text-green-600">✓</span>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                  
                  <div className="flex gap-2 pt-4 border-t">
                    <Button 
                      variant="outline" 
                      className="flex-1"
                      onClick={() => setShowPermissionsModal(false)}
                    >
                      İptal
                    </Button>
                    <Button 
                      className="flex-1 bg-green-600 hover:bg-green-700"
                      onClick={() => handleUpdatePermissions(selectedPersonnelForPermissions.permissions || [])}
                    >
                      Yetkileri Kaydet
                    </Button>
                  </div>
                </div>
              )}
            </DialogContent>
          </Dialog>

          {/* Admin Hesap Ayarları Modal */}
          <Dialog open={showAdminSettingsModal} onOpenChange={setShowAdminSettingsModal}>
            <DialogContent className="max-w-md">
              <DialogHeader>
                <DialogTitle>⚙️ Admin Hesap Ayarları</DialogTitle>
                <DialogDescription>
                  Kullanıcı adınızı ve şifrenizi değiştirin
                </DialogDescription>
              </DialogHeader>
              <form onSubmit={handleUpdateAdminSettings} className="space-y-4">
                <div className="bg-amber-50 p-3 rounded-lg border border-amber-200">
                  <p className="text-sm text-amber-800">
                    ⚠️ Şifrenizi değiştirirseniz yeniden giriş yapmanız gerekecektir.
                  </p>
                </div>
                
                <div>
                  <Label>Kullanıcı Adı</Label>
                  <Input
                    value={adminSettings.username}
                    onChange={(e) => setAdminSettings({...adminSettings, username: e.target.value})}
                    placeholder="admin"
                  />
                </div>
                
                <div className="border-t pt-4">
                  <p className="text-sm font-medium text-slate-700 mb-3">Şifre Değiştir</p>
                  <div className="space-y-3">
                    <div>
                      <Label>Mevcut Şifre *</Label>
                      <Input
                        type="password"
                        value={adminSettings.current_password}
                        onChange={(e) => setAdminSettings({...adminSettings, current_password: e.target.value})}
                        placeholder="Mevcut şifrenizi girin"
                        required
                      />
                    </div>
                    <div>
                      <Label>Yeni Şifre (opsiyonel)</Label>
                      <Input
                        type="password"
                        value={adminSettings.new_password}
                        onChange={(e) => setAdminSettings({...adminSettings, new_password: e.target.value})}
                        placeholder="Yeni şifre (boş bırakılırsa değişmez)"
                      />
                    </div>
                    {adminSettings.new_password && (
                      <div>
                        <Label>Yeni Şifre (Tekrar)</Label>
                        <Input
                          type="password"
                          value={adminSettings.new_password_confirm}
                          onChange={(e) => setAdminSettings({...adminSettings, new_password_confirm: e.target.value})}
                          placeholder="Yeni şifreyi tekrar girin"
                        />
                        {adminSettings.new_password !== adminSettings.new_password_confirm && adminSettings.new_password_confirm && (
                          <p className="text-xs text-red-500 mt-1">Şifreler eşleşmiyor</p>
                        )}
                      </div>
                    )}
                  </div>
                </div>
                
                <div className="flex gap-2 pt-2">
                  <Button 
                    type="button"
                    variant="outline" 
                    className="flex-1"
                    onClick={() => setShowAdminSettingsModal(false)}
                  >
                    İptal
                  </Button>
                  <Button 
                    type="submit"
                    className="flex-1 bg-blue-600 hover:bg-blue-700"
                    disabled={!adminSettings.current_password || (adminSettings.new_password && adminSettings.new_password !== adminSettings.new_password_confirm)}
                  >
                    Kaydet
                  </Button>
                </div>
              </form>
            </DialogContent>
          </Dialog>

          {/* Personel Görevleri Modal */}
          <Dialog open={showPersonnelAssignmentsModal} onOpenChange={setShowPersonnelAssignmentsModal}>
            <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto">
              <DialogHeader>
                <DialogTitle>📋 Maç Görevleri</DialogTitle>
                <DialogDescription>
                  {selectedPersonnelAssignments?.personnel_name} - Atanan maçlar ve katılım durumu
                </DialogDescription>
              </DialogHeader>
              {selectedPersonnelAssignments && (
                <div className="space-y-4">
                  {/* Özet Kartları */}
                  <div className="grid grid-cols-3 gap-3">
                    <div className="bg-blue-50 rounded-lg p-3 text-center">
                      <p className="text-2xl font-bold text-blue-700">{selectedPersonnelAssignments.total_assignments}</p>
                      <p className="text-xs text-blue-600">Toplam Görev</p>
                    </div>
                    <div className="bg-green-50 rounded-lg p-3 text-center">
                      <p className="text-2xl font-bold text-green-700">{selectedPersonnelAssignments.attended_count}</p>
                      <p className="text-xs text-green-600">Katıldı</p>
                    </div>
                    <div className="bg-red-50 rounded-lg p-3 text-center">
                      <p className="text-2xl font-bold text-red-700">{selectedPersonnelAssignments.total_assignments - selectedPersonnelAssignments.attended_count}</p>
                      <p className="text-xs text-red-600">Katılmadı</p>
                    </div>
                  </div>

                  {/* Görev Listesi */}
                  <div className="space-y-2">
                    {selectedPersonnelAssignments.assignments.length === 0 ? (
                      <div className="text-center py-8 text-slate-400">
                        <p>Henüz maç görevi atanmamış</p>
                      </div>
                    ) : (
                      selectedPersonnelAssignments.assignments.map((assignment) => (
                        <div key={assignment.assignment_id} className={`p-3 rounded-lg border ${assignment.attended ? 'bg-green-50 border-green-200' : 'bg-slate-50 border-slate-200'}`}>
                          <div className="flex items-center justify-between">
                            <div className="flex-1">
                              <div className="flex items-center gap-2 mb-1">
                                <Badge variant="outline" className="text-xs">
                                  {assignment.week}. Hafta
                                </Badge>
                                <span className="text-sm font-medium">
                                  {assignment.home_team_name} vs {assignment.away_team_name}
                                </span>
                              </div>
                              <div className="flex items-center gap-3 text-xs text-slate-500">
                                <span>📅 {assignment.date}</span>
                                <span>🕐 {assignment.time?.slice(0,5)}</span>
                                <span className="bg-purple-100 text-purple-700 px-2 py-0.5 rounded">
                                  {MATCH_PERSONNEL_ROLES.find(r => r.id === assignment.role)?.label || assignment.role}
                                </span>
                              </div>
                            </div>
                            <div className="flex items-center gap-2">
                              <Button
                                size="sm"
                                variant={assignment.attended ? 'default' : 'outline'}
                                className={assignment.attended ? 'bg-green-600 hover:bg-green-700' : ''}
                                onClick={() => updateAssignmentAttendance(assignment.assignment_id, !assignment.attended)}
                              >
                                {assignment.attended ? '✓ Geldi' : '✗ Gelmedi'}
                              </Button>
                            </div>
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                </div>
              )}
            </DialogContent>
          </Dialog>

          {/* Veritabanı Tab */}
          <TabsContent value="database" className="space-y-4 md:space-y-6">
            <DatabaseTab />
          </TabsContent>

          {/* Etkinlikler Tab */}
          <TabsContent value="etkinlik" className="space-y-4 md:space-y-6">
            <EventsTab events={events} fetchEvents={fetchEvents} />
          </TabsContent>

          {/* Blog Yazıları Tab */}
          <TabsContent value="blog" className="space-y-4 md:space-y-6">
            <BlogTab />
          </TabsContent>

          {/* ============ RAPORLAR (Kurumsal Redesign) ============ */}
          {/* ============ RAPORLAR (component) ============ */}
          <TabsContent value="analytics" className="space-y-6">
            <ReportsTab
              reservations={reservations}
              incomes={incomes}
              expenses={expenses}
              getSalonName={getSalonName}
              getCustomerName={getCustomerName}
              refereesTotalBalance={refereesTotalBalance}
              analyticsFilters={analyticsFilters}
              setAnalyticsFilters={setAnalyticsFilters}
              exportAnalyticsToExcel={exportAnalyticsToExcel}
            />
          </TabsContent>

          {/* Geri Bildirimler Tab */}
          <TabsContent value="feedback" className="space-y-4">
            <FeedbackTab />
          </TabsContent>

          {/* İşlem Kayıtları Tab */}
          <TabsContent value="activity-log" className="space-y-4">
            <ActivityLogTab />
          </TabsContent>

          {/* Görevler Tab */}
          <TabsContent value="tasks-overview" className="space-y-4">
            <TasksTab personnelList={personnelList} />
          </TabsContent>

          {/* Rutinler Tab */}
          <TabsContent value="routines" className="space-y-4">
            <RoutinesTab personnelList={personnelList} />
          </TabsContent>

          {/* Mesai (PDKS) Tab */}
          <TabsContent value="mesai" className="space-y-4">
            <AttendancePanel personnelList={personnelList} isAdmin={!isPersonnel || personnelPerms.includes('mesai') || personnelPerms.includes('personel')} isSuperAdmin={!isPersonnel} />
          </TabsContent>

          {/* İzinler Tab */}
          <TabsContent value="izinler" className="space-y-4">
            <LeavesTab personnelList={personnelList} />
          </TabsContent>

          {/* Demirbaş Tab */}
          <TabsContent value="demirbas" className="space-y-4">
            <DemirbasTab salons={salons} />
          </TabsContent>

          {/* Primler Tab (sadece admin) */}
          {!isPersonnel && (
            <TabsContent value="bonuses" className="space-y-4">
              <BonusesTab />
            </TabsContent>
          )}

          {/* KDV Tab */}
          <TabsContent value="vat" className="space-y-4">
            <VatTab />
          </TabsContent>

          {/* Organizasyonlar Tab */}
          <TabsContent value="organizations" className="space-y-4">
            <OrganizationsTab
              autoOpenNew={orgAutoOpenNew}
              onAutoOpenConsumed={() => setOrgAutoOpenNew(false)}
              salons={salons}
              customers={customers}
              personnelList={personnelList}
              isAdmin={!isPersonnel}
              onReservationsChanged={() => { refreshReservationTab(); fetchTodayReservations(); }}
            />
          </TabsContent>
        </Tabs>
        
        {/* Customer Reservations Modal */}
        <Dialog open={showCustomerModal} onOpenChange={setShowCustomerModal}>
          <DialogContent className="max-w-4xl max-h-[80vh] overflow-y-auto">
            <DialogHeader>
              <DialogTitle className="flex items-center gap-2">
                <Users className="w-5 h-5" />
                {selectedCustomer?.name} - Rezervasyonları
              </DialogTitle>
              <DialogDescription>
                Bu müşterinin tüm rezervasyon geçmişi
              </DialogDescription>
            </DialogHeader>
            
            <div className="space-y-4">
              {customerReservations.length === 0 ? (
                <p className="text-slate-500 text-center py-8">Bu müşterinin rezervasyonu bulunmuyor</p>
              ) : (
                <div className="overflow-x-auto">
                  <table className="w-full">
                    <thead className="bg-slate-50">
                      <tr>
                        <th className="text-left p-3 font-semibold">Tarih</th>
                        <th className="text-left p-3 font-semibold">Saat</th>
                        <th className="text-left p-3 font-semibold">Salon</th>
                        <th className="text-left p-3 font-semibold">Süre</th>
                        <th className="text-left p-3 font-semibold">Tutar</th>
                        <th className="text-left p-3 font-semibold">Durum</th>
                      </tr>
                    </thead>
                    <tbody>
                      {customerReservations.map((reservation) => (
                        <tr key={reservation.id} className="border-t">
                          <td className="p-3">{reservation.date}</td>
                          <td className="p-3">{reservation.start_time} - {reservation.end_time}</td>
                          <td className="p-3">
                            <div className="flex items-center gap-2">
                              <div className={`w-3 h-3 rounded-full ${getSalonColor(reservation.salon_id).replace('bg-gradient-to-r from-', 'bg-').split(' ')[0]}`}></div>
                              {getSalonName(reservation.salon_id)}
                            </div>
                          </td>
                          <td className="p-3">{reservation.duration_hours}h</td>
                          <td className="p-3 font-semibold">₺{reservation.total_amount}</td>
                          <td className="p-3">{getPaymentStatusBadge(reservation.payment_status)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
              
              {selectedCustomer && (
                <div className="mt-6 p-4 bg-slate-50 rounded-lg">
                  <h3 className="font-semibold mb-2">Müşteri Bilgileri</h3>
                  <div className="grid grid-cols-2 gap-4 text-sm">
                    <div>
                      <span className="font-medium">Telefon:</span> {selectedCustomer.phone || 'Belirtilmemiş'}
                    </div>
                    <div>
                      <span className="font-medium">E-posta:</span> {selectedCustomer.email || 'Belirtilmemiş'}
                    </div>
                    <div>
                      <span className="font-medium">Cari Bakiye:</span> 
                      <span className={selectedCustomer.balance > 0 ? 'text-red-600' : 'text-green-600'}>
                        {selectedCustomer.balance > 0 ? `₺${selectedCustomer.balance?.toFixed(2)} (Borç)` : 'Borç Yok'}
                      </span>
                    </div>
                    <div>
                      <span className="font-medium">Toplam Rezervasyon:</span> {customerReservations.length}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </DialogContent>
        </Dialog>
        {/* Edit Reservation Modal */}
        <Dialog open={showEditReservationModal} onOpenChange={setShowEditReservationModal}>
          <DialogContent className="max-w-md">
            <DialogHeader>
              <DialogTitle>Rezervasyon Düzenle</DialogTitle>
              <DialogDescription>Rezervasyon bilgilerini güncelleyin</DialogDescription>
            </DialogHeader>
            {editingReservation && (
              <form onSubmit={handleUpdateReservation} className="space-y-4">
                <div>
                  <Label>Tarih</Label>
                  <Input
                    type="date"
                    value={editingReservation.date}
                    onChange={(e) => setEditingReservation({...editingReservation, date: e.target.value})}
                    required
                  />
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <Label>Başlangıç</Label>
                    <Input
                      type="time"
                      value={editingReservation.start_time?.slice(0, 5)}
                      onChange={(e) => setEditingReservation({...editingReservation, start_time: e.target.value})}
                      required
                    />
                  </div>
                  <div>
                    <Label>Bitiş</Label>
                    <Input
                      type="time"
                      value={editingReservation.end_time?.slice(0, 5)}
                      onChange={(e) => setEditingReservation({...editingReservation, end_time: e.target.value})}
                      required
                    />
                  </div>
                </div>
                <div>
                  <Label>
                    {editingReservation.invoice_issued ? "Tutar (KDV'siz Matrah) (₺)" : "Toplam Tutar (₺)"}
                  </Label>
                  <Input
                    type="number"
                    step="0.01"
                    value={editingReservation.total_amount || ''}
                    onChange={(e) => setEditingReservation({...editingReservation, total_amount: parseFloat(e.target.value)})}
                    data-testid="edit-reservation-total-amount"
                  />
                </div>
                <div className="rounded-lg border border-amber-200 bg-amber-50/60 p-3 space-y-2">
                  <div className="flex items-center gap-2">
                    <input
                      type="checkbox"
                      id="edit_invoice_issued"
                      checked={!!editingReservation.invoice_issued}
                      onChange={(e) => setEditingReservation({...editingReservation, invoice_issued: e.target.checked})}
                      className="h-4 w-4 rounded border-gray-300"
                      data-testid="edit-reservation-invoice-checkbox"
                    />
                    <Label htmlFor="edit_invoice_issued" className="cursor-pointer font-semibold text-amber-900">
                      Faturalı İşlem (+%{VAT_RATE} KDV)
                    </Label>
                  </div>
                  {editingReservation.invoice_issued && (
                    <div className="text-xs text-amber-900 grid grid-cols-3 gap-2" data-testid="edit-reservation-vat-preview">
                      <div>Matrah<div className="font-bold text-sm">{formatTL(vatPreview(editingReservation.total_amount).base)}</div></div>
                      <div>KDV %{VAT_RATE}<div className="font-bold text-sm">{formatTL(vatPreview(editingReservation.total_amount).vat)}</div></div>
                      <div>Toplam<div className="font-bold text-sm text-emerald-700">{formatTL(vatPreview(editingReservation.total_amount).total)}</div></div>
                    </div>
                  )}
                  {editingReservation.invoice_issued && (
                    <div>
                      <Label className="text-[11px] text-amber-900">Vade Tarihi (tahsilat son günü)</Label>
                      <Input type="date" className="h-9 bg-white"
                        value={String(editingReservation.invoice_due_date || '').slice(0, 10)}
                        onChange={(e) => setEditingReservation({ ...editingReservation, invoice_due_date: e.target.value || null })}
                        data-testid="edit-reservation-invoice-due-date" />
                    </div>
                  )}
                  {editingReservation.invoice_issued && (
                    <p className="text-[11px] text-amber-800">Faturalı maçta hakem bu maçtan para almaz; ücretini başka maçtan alır.</p>
                  )}
                </div>
                <div>
                  <Label>Ödenen / Kapora Tutarı (₺)</Label>
                  <Input
                    type="number"
                    step="0.01"
                    value={editingReservation.paid_amount || ''}
                    onChange={(e) => setEditingReservation({...editingReservation, paid_amount: parseFloat(e.target.value)})}
                    placeholder="Alınan kapora / ön ödeme"
                  />
                </div>
                {(editingReservation.paid_amount || 0) > 0 && (
                  <div>
                    <Label>Kapora Hangi Kasaya?</Label>
                    <Select
                      value={editingReservation.payment_method || 'nakit'}
                      onValueChange={(value) => setEditingReservation({...editingReservation, payment_method: value})}
                    >
                      <SelectTrigger data-testid="edit-reservation-payment-method"><SelectValue /></SelectTrigger>
                      <SelectContent>
                        <SelectItem value="nakit">💵 Nakit</SelectItem>
                        <SelectItem value="garanti_bbva">🏦 Garanti BBVA</SelectItem>
                        <SelectItem value="bostanci">🏢 Bostancı</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                )}
                <div>
                  <Label>Hakem</Label>
                  <Select 
                    value={editingReservation.referee_id || 'null'} 
                    onValueChange={(value) => setEditingReservation({...editingReservation, referee_id: value === 'null' ? null : value})}
                  >
                    <SelectTrigger>
                      <SelectValue placeholder="Hakem seçin (opsiyonel)" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="null">Hakem Yok</SelectItem>
                      {referees.map((referee) => (
                        <SelectItem key={referee.id} value={referee.id}>{referee.name}</SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
                {editingReservation.referee_id && editingReservation.referee_id !== 'null' && (
                  <div>
                    <Label>Hakem Ücreti (₺)</Label>
                    <Input
                      type="number"
                      step="0.01"
                      value={editingReservation.referee_fee || ''}
                      onChange={(e) => setEditingReservation({...editingReservation, referee_fee: parseFloat(e.target.value) || 0})}
                      placeholder="Hakem ücreti girin"
                    />
                  </div>
                )}
                <div>
                  <Label>Notlar</Label>
                  <Textarea
                    value={editingReservation.notes || ''}
                    onChange={(e) => setEditingReservation({...editingReservation, notes: e.target.value})}
                  />
                </div>
                <Button type="submit" className="w-full bg-blue-600 hover:bg-blue-700">
                  Güncelle
                </Button>
              </form>
            )}
          </DialogContent>
        </Dialog>

        {/* Edit Salon Modal */}
        <Dialog open={showEditSalonModal} onOpenChange={setShowEditSalonModal}>
          <DialogContent className="max-w-md">
            <DialogHeader>
              <DialogTitle>Salon Düzenle</DialogTitle>
              <DialogDescription>Salon bilgilerini güncelleyin</DialogDescription>
            </DialogHeader>
            {editingSalon && (
              <form onSubmit={handleUpdateSalon} className="space-y-4">
                <div>
                  <Label>Salon Adı *</Label>
                  <Input
                    value={editingSalon.name}
                    onChange={(e) => setEditingSalon({...editingSalon, name: e.target.value})}
                    required
                  />
                </div>
                <div>
                  <Label>Konum</Label>
                  <Input
                    value={editingSalon.location || ''}
                    onChange={(e) => setEditingSalon({...editingSalon, location: e.target.value})}
                  />
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <Label>Kapasite</Label>
                    <Input
                      type="number"
                      value={editingSalon.capacity || ''}
                      onChange={(e) => setEditingSalon({...editingSalon, capacity: parseInt(e.target.value)})}
                    />
                  </div>
                  <div>
                    <Label>Telefon</Label>
                    <Input
                      value={editingSalon.phone || ''}
                      onChange={(e) => setEditingSalon({...editingSalon, phone: e.target.value})}
                    />
                  </div>
                </div>
                <div className="grid grid-cols-3 gap-2">
                  <div>
                    <Label>1 Saat (₺)</Label>
                    <Input
                      type="number"
                      step="0.01"
                      value={editingSalon.hourly_rate_1h}
                      onChange={(e) => setEditingSalon({...editingSalon, hourly_rate_1h: parseFloat(e.target.value)})}
                      required
                    />
                  </div>
                  <div>
                    <Label>1.5 Saat (₺)</Label>
                    <Input
                      type="number"
                      step="0.01"
                      value={editingSalon.hourly_rate_1_5h}
                      onChange={(e) => setEditingSalon({...editingSalon, hourly_rate_1_5h: parseFloat(e.target.value)})}
                      required
                    />
                  </div>
                  <div>
                    <Label>2 Saat (₺)</Label>
                    <Input
                      type="number"
                      step="0.01"
                      value={editingSalon.hourly_rate_2h}
                      onChange={(e) => setEditingSalon({...editingSalon, hourly_rate_2h: parseFloat(e.target.value)})}
                      required
                    />
                  </div>
                </div>
                <div className="rounded-lg border border-rose-200 bg-rose-50/60 p-3">
                  <div className="flex items-center gap-2">
                    <input
                      type="checkbox"
                      id="edit_exclude_from_kasa"
                      checked={!!editingSalon.exclude_from_kasa}
                      onChange={(e) => setEditingSalon({...editingSalon, exclude_from_kasa: e.target.checked})}
                      className="h-4 w-4 rounded border-gray-300"
                      data-testid="salon-exclude-kasa-checkbox"
                    />
                    <Label htmlFor="edit_exclude_from_kasa" className="cursor-pointer font-semibold text-rose-900">
                      Bu sahanın işlemleri kasaya işlenmesin
                    </Label>
                  </div>
                  <p className="text-[11px] text-rose-800 mt-1">
                    İşaretliyse bu sahanın {KASA_EXCLUSION_START_LABEL} ve sonrasındaki işlemleri kasaya (gelir/gider) yazılmaz —
                    rezervasyon, cari hesap ve hakem takibi normal devam eder, sadece bilgi amaçlı görünür.
                  </p>
                </div>
                <div>
                  <Label>Açıklama</Label>
                  <Textarea
                    value={editingSalon.description || ''}
                    onChange={(e) => setEditingSalon({...editingSalon, description: e.target.value})}
                  />
                </div>
                <Button type="submit" className="w-full bg-purple-600 hover:bg-purple-700">
                  Güncelle
                </Button>
              </form>
            )}
          </DialogContent>
        </Dialog>

        {/* Edit Income Modal */}
        <Dialog open={showEditIncomeModal} onOpenChange={setShowEditIncomeModal}>
          <DialogContent className="max-w-md">
            <DialogHeader>
              <DialogTitle>Gelir Düzenle</DialogTitle>
              <DialogDescription>Gelir kaydını güncelleyin</DialogDescription>
            </DialogHeader>
            {editingIncome && (
              <form onSubmit={handleUpdateIncome} className="space-y-4">
                <div>
                  <Label>Başlık *</Label>
                  <Input
                    value={editingIncome.title}
                    onChange={(e) => setEditingIncome({...editingIncome, title: e.target.value})}
                    required
                  />
                </div>
                <div>
                  <Label>Tutar (₺) *</Label>
                  <Input
                    type="number"
                    step="0.01"
                    value={editingIncome.amount}
                    onChange={(e) => setEditingIncome({...editingIncome, amount: parseFloat(e.target.value)})}
                    required
                  />
                </div>
                <div>
                  <Label>Tarih</Label>
                  <Input
                    type="date"
                    value={editingIncome.date}
                    onChange={(e) => setEditingIncome({...editingIncome, date: e.target.value})}
                    required
                  />
                </div>
                <div>
                  <Label>Notlar</Label>
                  <Textarea
                    value={editingIncome.notes || ''}
                    onChange={(e) => setEditingIncome({...editingIncome, notes: e.target.value})}
                  />
                </div>
                <Button type="submit" className="w-full bg-green-600 hover:bg-green-700">
                  Güncelle
                </Button>
              </form>
            )}
          </DialogContent>
        </Dialog>

        {/* Edit Expense Modal */}
        <Dialog open={showEditExpenseModal} onOpenChange={setShowEditExpenseModal}>
          <DialogContent className="max-w-md">
            <DialogHeader>
              <DialogTitle>Gider Düzenle</DialogTitle>
              <DialogDescription>Gider kaydını güncelleyin</DialogDescription>
            </DialogHeader>
            {editingExpense && (
              <form onSubmit={handleUpdateExpense} className="space-y-4">
                <div>
                  <Label>Başlık *</Label>
                  <Input
                    value={editingExpense.title}
                    onChange={(e) => setEditingExpense({...editingExpense, title: e.target.value})}
                    required
                  />
                </div>
                <div>
                  <Label>Tutar (₺) *</Label>
                  <Input
                    type="number"
                    step="0.01"
                    value={editingExpense.amount}
                    onChange={(e) => setEditingExpense({...editingExpense, amount: parseFloat(e.target.value)})}
                    required
                  />
                </div>
                <div>
                  <Label>Tarih</Label>
                  <Input
                    type="date"
                    value={editingExpense.date}
                    onChange={(e) => setEditingExpense({...editingExpense, date: e.target.value})}
                    required
                  />
                </div>
                <div>
                  <Label>Notlar</Label>
                  <Textarea
                    value={editingExpense.notes || ''}
                    onChange={(e) => setEditingExpense({...editingExpense, notes: e.target.value})}
                  />
                </div>
                <Button type="submit" className="w-full bg-red-600 hover:bg-red-700">
                  Güncelle
                </Button>
              </form>
            )}
          </DialogContent>
        </Dialog>

        {/* Edit Referee Modal */}
        <Dialog open={showEditRefereeModal} onOpenChange={setShowEditRefereeModal}>
          <DialogContent className="max-w-md">
            <DialogHeader>
              <DialogTitle>Hakem Düzenle</DialogTitle>
              <DialogDescription>Hakem bilgilerini güncelleyin</DialogDescription>
            </DialogHeader>
            {editingReferee && (
              <form onSubmit={handleUpdateReferee} className="space-y-4">
                <div>
                  <Label>Hakem Adı *</Label>
                  <Input
                    value={editingReferee.name}
                    onChange={(e) => setEditingReferee({...editingReferee, name: e.target.value})}
                    required
                  />
                </div>
                <div>
                  <Label>Telefon</Label>
                  <Input
                    value={editingReferee.phone || ''}
                    onChange={(e) => setEditingReferee({...editingReferee, phone: e.target.value})}
                  />
                </div>
                <div>
                  <Label>Seviye</Label>
                  <Select 
                    value={editingReferee.level} 
                    onValueChange={(value) => setEditingReferee({...editingReferee, level: value})}
                  >
                    <SelectTrigger>
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="junior">Junior</SelectItem>
                      <SelectItem value="senior">Senior</SelectItem>
                      <SelectItem value="fifa">FIFA</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                <div>
                  <Label>Maç Başı Ücret (₺)</Label>
                  <Input
                    type="number"
                    step="0.01"
                    value={editingReferee.fee_per_match}
                    onChange={(e) => setEditingReferee({...editingReferee, fee_per_match: parseFloat(e.target.value)})}
                  />
                </div>
                <Button type="submit" className="w-full bg-orange-600 hover:bg-orange-700">
                  Güncelle
                </Button>
              </form>
            )}
          </DialogContent>
        </Dialog>

        {/* Edit Team Modal */}
        <Dialog open={showEditTeamModal} onOpenChange={setShowEditTeamModal}>
          <DialogContent className="max-w-md">
            <DialogHeader>
              <DialogTitle>Takım Düzenle</DialogTitle>
              <DialogDescription>Takım bilgilerini güncelleyin</DialogDescription>
            </DialogHeader>
            {editingTeam && (
              <form onSubmit={handleUpdateTeam} className="space-y-4">
                <div>
                  <Label>Takım Adı *</Label>
                  <Input
                    value={editingTeam.name}
                    onChange={(e) => setEditingTeam({...editingTeam, name: e.target.value})}
                    required
                  />
                </div>
                <div>
                  <Label>Kaptan</Label>
                  <Input
                    value={editingTeam.captain || ''}
                    onChange={(e) => setEditingTeam({...editingTeam, captain: e.target.value})}
                  />
                </div>
                <div>
                  <Label>Telefon</Label>
                  <Input
                    value={editingTeam.phone || ''}
                    onChange={(e) => setEditingTeam({...editingTeam, phone: e.target.value})}
                  />
                </div>
                <div>
                  <Label>Logo URL</Label>
                  <Input
                    value={editingTeam.logo_url || ''}
                    onChange={(e) => setEditingTeam({...editingTeam, logo_url: e.target.value})}
                    placeholder="https://..."
                  />
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <Label>Kayıt Ücreti (₺)</Label>
                    <Input
                      type="number"
                      step="0.01"
                      value={editingTeam.registration_fee}
                      onChange={(e) => setEditingTeam({...editingTeam, registration_fee: parseFloat(e.target.value)})}
                    />
                  </div>
                  <div>
                    <Label>Maç Başı Ücret (₺)</Label>
                    <Input
                      type="number"
                      step="0.01"
                      value={editingTeam.match_fee_per_game || 0}
                      onChange={(e) => setEditingTeam({...editingTeam, match_fee_per_game: parseFloat(e.target.value)})}
                    />
                  </div>
                </div>
                <Button type="submit" className="w-full bg-purple-600 hover:bg-purple-700">
                  Güncelle
                </Button>
              </form>
            )}
          </DialogContent>
        </Dialog>

        {/* Reservation Detail Modal */}
        <Dialog open={showReservationDetailModal} onOpenChange={setShowReservationDetailModal}>
          <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
            <DialogHeader>
              <DialogTitle className="flex items-center gap-2">
                <CalendarDays className="w-5 h-5 text-blue-600" />
                Rezervasyon Detayı
              </DialogTitle>
              <DialogDescription>Rezervasyon bilgileri ve ekstra giderler</DialogDescription>
            </DialogHeader>
            {selectedReservationDetail && (
              <div className="space-y-6">
                {/* Temel Bilgiler */}
                <div className="grid grid-cols-2 gap-4">
                  <Card className="bg-slate-50">
                    <CardContent className="pt-4">
                      <p className="text-xs text-slate-500 mb-1">Müşteri</p>
                      <p className="font-semibold text-lg">{selectedReservationDetail.customer_name}</p>
                      <p className="text-sm text-slate-600">{selectedReservationDetail.customer_phone}</p>
                    </CardContent>
                  </Card>
                  <Card className="bg-slate-50">
                    <CardContent className="pt-4">
                      <p className="text-xs text-slate-500 mb-1">Salon</p>
                      <p className="font-semibold text-lg">{selectedReservationDetail.salon_name}</p>
                    </CardContent>
                  </Card>
                </div>
                
                <div className="grid grid-cols-3 gap-4">
                  <Card className="bg-blue-50">
                    <CardContent className="pt-4 text-center">
                      <p className="text-xs text-blue-600 mb-1">Tarih</p>
                      <p className="font-bold text-blue-900">{selectedReservationDetail.date}</p>
                    </CardContent>
                  </Card>
                  <Card className="bg-purple-50">
                    <CardContent className="pt-4 text-center">
                      <p className="text-xs text-purple-600 mb-1">Saat</p>
                      <p className="font-bold text-purple-900">
                        {selectedReservationDetail.start_time?.slice(0,5)} - {selectedReservationDetail.end_time?.slice(0,5)}
                      </p>
                    </CardContent>
                  </Card>
                  <Card className="bg-green-50">
                    <CardContent className="pt-4 text-center">
                      <p className="text-xs text-green-600 mb-1">Toplam Tutar</p>
                      <p className="font-bold text-green-900">₺{selectedReservationDetail.total_amount?.toLocaleString()}</p>
                    </CardContent>
                  </Card>
                </div>
                
                {/* Hakem Bilgisi */}
                {selectedReservationDetail.referee_name && (
                  <Card className="bg-orange-50 border-orange-200">
                    <CardContent className="pt-4">
                      <div className="flex items-center justify-between">
                        <div>
                          <p className="text-xs text-orange-600 mb-1">Hakem</p>
                          <p className="font-semibold text-orange-900">{selectedReservationDetail.referee_name}</p>
                        </div>
                        <div className="text-right">
                          <p className="text-xs text-orange-600 mb-1">Hakem Ücreti</p>
                          <p className="font-bold text-orange-900">₺{selectedReservationDetail.referee_fee?.toLocaleString()}</p>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                )}
                
                {/* Notlar */}
                {selectedReservationDetail.notes && (
                  <Card className="bg-yellow-50 border-yellow-200">
                    <CardContent className="pt-4">
                      <p className="text-xs text-yellow-700 mb-1">📝 Notlar</p>
                      <p className="text-yellow-900">{selectedReservationDetail.notes}</p>
                    </CardContent>
                  </Card>
                )}
                
                {/* Finansal Özet - Kasaya Kalacak */}
                <Card className="bg-gradient-to-r from-emerald-50 to-teal-50 border-emerald-200">
                  <CardContent className="pt-4">
                    <p className="text-sm font-semibold text-emerald-800 mb-3">💰 Finansal Özet</p>
                    <div className="space-y-2 text-sm">
                      {(() => {
                        const expTotal = reservationExpenses.reduce((sum, e) => sum + (e.amount || 0), 0);
                        const _hasRef = !!selectedReservationDetail.referee_id && selectedReservationDetail.referee_id !== 'null';
                        // Hakemli maçta kapora HER ZAMAN düşülür; hakemsizde ödendiğinde tamamı kasada kalır.
                        const kapora = _hasRef
                          ? (selectedReservationDetail.paid_amount || 0)
                          : (selectedReservationDetail.payment_status !== 'odendi' ? (selectedReservationDetail.paid_amount || 0) : 0);
                        const net = (selectedReservationDetail.total_amount || 0) - kapora - (selectedReservationDetail.referee_fee || 0) - expTotal;
                        const hasReferee = selectedReservationDetail.referee_fee > 0;
                        return (
                          <>
                            <div className="flex justify-between">
                              <span className="text-slate-600">Toplam Tutar:</span>
                              <span className="font-medium">₺{(selectedReservationDetail.total_amount || 0).toLocaleString()}</span>
                            </div>
                            {kapora > 0 && (
                              <div className="flex justify-between text-blue-700">
                                <span>Alınan Kapora ({getPaymentMethodLabel(selectedReservationDetail.payment_method)}):</span>
                                <span className="font-medium" data-testid="detail-kapora-amount">-₺{kapora.toLocaleString()}</span>
                              </div>
                            )}
                            {hasReferee && (
                              <div className="flex justify-between text-orange-700">
                                <span>Hakem Ücreti:</span>
                                <span className="font-medium">-₺{(selectedReservationDetail.referee_fee || 0).toLocaleString()}</span>
                              </div>
                            )}
                            {expTotal > 0 && (
                              <div className="flex justify-between text-red-700">
                                <span>Ekstra Giderler:</span>
                                <span className="font-medium">-₺{expTotal.toLocaleString()}</span>
                              </div>
                            )}
                            <div className="border-t pt-2 mt-2">
                              <div className="flex justify-between text-emerald-800">
                                <span className="font-semibold">
                                  {hasReferee ? 'Hakemden Tahsil Edilecek (Net):' : 'Kasaya Kalacak Net:'}
                                </span>
                                <span className="font-bold text-lg" data-testid="detail-net-amount">
                                  {salons.find(s => s.id === selectedReservationDetail.salon_id)?.exclude_from_kasa
                                    ? `₺${net.toLocaleString()} (kasaya işlenmez)`
                                    : `₺${net.toLocaleString()}`}
                                </span>
                              </div>
                              {hasReferee && (
                                <p className="text-xs text-emerald-600 mt-1">
                                  * Kapora kasaya yatırıldı; hakem kalan net tutarı teslim edecek
                                </p>
                              )}
                            </div>
                          </>
                        );
                      })()}
                    </div>
                  </CardContent>
                </Card>
                
                {/* Fatura Dosyaları (faturalı organizasyonlar) */}
                {selectedReservationDetail.invoice_issued && (
                  <InvoiceFiles reservationId={selectedReservationDetail.id} />
                )}

                {/* Kasaya işlenmeyen saha uyarısı */}
                {salons.find(s => s.id === selectedReservationDetail.salon_id)?.exclude_from_kasa && (
                  <Card className="bg-slate-100 border-slate-300" data-testid="kasa-excluded-notice">
                    <CardContent className="pt-4">
                      <p className="text-sm font-semibold text-slate-800">Bu saha kasaya işlenmiyor</p>
                      <p className="text-xs text-slate-600 mt-1">
                        {KASA_EXCLUSION_START_LABEL} ve sonrasındaki işlemler kasaya (gelir/gider) yazılmaz.
                        Tutarlar sadece bilgi/takip amaçlıdır; cari hesap ve hakem takibi normal devam eder.
                      </p>
                    </CardContent>
                  </Card>
                )}

                {/* Ekstra Giderler */}
                <Card>
                  <CardHeader className="pb-2">
                    <CardTitle className="text-base flex items-center gap-2">
                      <Receipt className="w-4 h-4 text-red-600" />
                      Ekstra Giderler
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="space-y-4">
                    {/* Mevcut Giderler */}
                    {reservationExpenses.length > 0 ? (
                      <div className="space-y-2">
                        {reservationExpenses.map((exp) => (
                          <div key={exp.id} className="flex items-center justify-between p-3 bg-red-50 rounded-lg">
                            <div>
                              <p className="font-medium text-red-900">{exp.description}</p>
                              <p className="text-xs text-red-600">{exp.date}</p>
                            </div>
                            <div className="flex items-center gap-2">
                              <span className="font-bold text-red-700">-₺{exp.amount?.toLocaleString()}</span>
                              <Button
                                size="sm"
                                variant="ghost"
                                onClick={() => deleteReservationExpense(exp.id)}
                                className="h-7 w-7 p-0 text-red-600 hover:bg-red-100"
                              >
                                <Trash2 className="w-3 h-3" />
                              </Button>
                            </div>
                          </div>
                        ))}
                        <div className="pt-2 border-t">
                          <p className="text-sm text-right font-semibold text-red-700">
                            Toplam Gider: -₺{reservationExpenses.reduce((sum, e) => sum + (e.amount || 0), 0).toLocaleString()}
                          </p>
                        </div>
                      </div>
                    ) : (
                      <p className="text-slate-500 text-sm text-center py-4">Henüz ekstra gider eklenmemiş</p>
                    )}
                    
                    {/* Yeni Gider Ekleme Formu */}
                    <form onSubmit={addReservationExpense} className="pt-4 border-t space-y-3">
                      <p className="text-sm font-medium text-slate-700">Yeni Gider Ekle</p>
                      <div className="flex gap-2 text-xs">
                        <button
                          type="button"
                          onClick={() => setNewReservationExpense({...newReservationExpense, kind: 'normal'})}
                          className={`px-3 py-1.5 rounded-full border transition-all ${(newReservationExpense.kind || 'normal') === 'normal' ? 'bg-slate-900 text-white border-slate-900' : 'bg-white text-slate-600 border-slate-200'}`}
                          data-testid="expense-kind-normal"
                        >
                          Normal Gider
                        </button>
                        <button
                          type="button"
                          onClick={() => setNewReservationExpense({...newReservationExpense, kind: 'cross_match_fee'})}
                          className={`px-3 py-1.5 rounded-full border transition-all ${newReservationExpense.kind === 'cross_match_fee' ? 'bg-amber-600 text-white border-amber-600' : 'bg-white text-amber-700 border-amber-200'}`}
                          data-testid="expense-kind-cross"
                        >
                          Başka maçtan ücret aldı
                        </button>
                      </div>
                      {newReservationExpense.kind === 'cross_match_fee' && (
                        <div className="space-y-2 rounded-lg bg-amber-50 border border-amber-200 p-3">
                          <p className="text-xs text-amber-900">
                            Hakem, ücretini alamadığı (faturalı/havaleli) maçın parasını bu maçtan aldı.
                            Tutar bu maçta teslim edeceğinden düşülür, seçilen maçta "ücreti alındı" olarak işaretlenir.
                          </p>
                          <Label className="text-xs">Ücretini alamadığı maç</Label>
                          <Select
                            value={newReservationExpense.source_reservation_id || ''}
                            onValueChange={(v) => setNewReservationExpense({...newReservationExpense, source_reservation_id: v})}
                          >
                            <SelectTrigger data-testid="cross-match-source-select"><SelectValue placeholder="Maç seçin" /></SelectTrigger>
                            <SelectContent>
                              {reservations
                                .filter(r => r.id !== selectedReservationDetail.id
                                  && r.referee_id === selectedReservationDetail.referee_id
                                  && (r.invoice_issued || r.paid_via_transfer))
                                .slice(0, 50)
                                .map(r => (
                                  <SelectItem key={r.id} value={r.id}>
                                    {r.date} · {getCustomerName(r.customer_id)} · Ücret ₺{(r.referee_fee || 0).toLocaleString('tr-TR')}
                                    {r.referee_fee_settled_from ? ' (alınmış)' : ''}
                                  </SelectItem>
                                ))}
                            </SelectContent>
                          </Select>
                        </div>
                      )}
                      <div className="grid grid-cols-3 gap-2">
                        <div>
                          <Input
                            type="number"
                            step="0.01"
                            value={newReservationExpense.amount}
                            onChange={(e) => setNewReservationExpense({...newReservationExpense, amount: e.target.value})}
                            placeholder="Tutar (₺)"
                            required
                            data-testid="expense-amount-input"
                          />
                        </div>
                        <div className="col-span-2">
                          <Input
                            value={newReservationExpense.kind === 'cross_match_fee' ? 'Otomatik açıklama oluşturulacak' : newReservationExpense.description}
                            onChange={(e) => setNewReservationExpense({...newReservationExpense, description: e.target.value})}
                            placeholder="Açıklama (örn: Su, top)"
                            disabled={newReservationExpense.kind === 'cross_match_fee'}
                            required={newReservationExpense.kind !== 'cross_match_fee'}
                            data-testid="expense-description-input"
                          />
                        </div>
                      </div>
                      <Button type="submit" size="sm" className={`w-full ${newReservationExpense.kind === 'cross_match_fee' ? 'bg-amber-600 hover:bg-amber-700' : 'bg-red-600 hover:bg-red-700'}`} data-testid="expense-submit-btn">
                        <Plus className="w-4 h-4 mr-1" />
                        {newReservationExpense.kind === 'cross_match_fee' ? 'Hakem Ücretini Kaydet' : 'Gider Ekle'}
                      </Button>
                    </form>
                  </CardContent>
                </Card>
                
                {/* Havale ile Ödendi → Bankaya Çek (sadece hakemli rezervasyonlar) */}
                {selectedReservationDetail.referee_name && (selectedReservationDetail.referee_fee || 0) > 0 && (
                  selectedReservationDetail.paid_via_transfer ? (
                    <Card className="bg-blue-50 border-blue-300" data-testid="reservation-transfer-status">
                      <CardContent className="pt-4">
                        <div className="flex items-center justify-between gap-3">
                          <div className="flex items-center gap-2">
                            <Landmark className="w-5 h-5 text-blue-600" />
                            <div>
                              <p className="font-semibold text-blue-900">Havale ile ödendi (Banka)</p>
                              <p className="text-xs text-blue-600">
                                Tam tutar bankaya işlendi · hakem bekleyen listesinde görünmüyor
                              </p>
                            </div>
                          </div>
                          <Button
                            variant="outline"
                            size="sm"
                            onClick={undoReservationTransfer}
                            disabled={resTransferLoading}
                            className="text-rose-600 border-rose-300 hover:bg-rose-50"
                            data-testid="undo-transfer-btn"
                          >
                            <RotateCcw className="w-4 h-4 mr-1" /> Havaleyi Geri Al
                          </Button>
                        </div>
                      </CardContent>
                    </Card>
                  ) : (
                    <Card className="bg-blue-50 border-blue-200" data-testid="reservation-transfer-action">
                      <CardContent className="pt-4">
                        <div className="flex items-center justify-between gap-3">
                          <div className="flex items-center gap-2">
                            <Landmark className="w-5 h-5 text-blue-600" />
                            <div>
                              <p className="font-semibold text-blue-900">Müşteri havale mi yaptı?</p>
                              <p className="text-xs text-blue-600">
                                Ödeme direkt bankaya geçtiyse hakem profiline düşürmeden işle
                              </p>
                            </div>
                          </div>
                          <Button
                            size="sm"
                            onClick={() => { setResTransferMethod('garanti_bbva'); setShowResTransferModal(true); }}
                            className="bg-blue-600 hover:bg-blue-700"
                            data-testid="open-transfer-btn"
                          >
                            <Landmark className="w-4 h-4 mr-1" /> Havale → Bankaya Çek
                          </Button>
                        </div>
                      </CardContent>
                    </Card>
                  )
                )}
                
                {/* İşlem Butonları */}
                <div className="flex gap-2">
                  <Button
                    variant="outline"
                    onClick={() => {
                      setEditingReservation({...selectedReservationDetail});
                      setShowEditReservationModal(true);
                      setShowReservationDetailModal(false);
                    }}
                    className="flex-1"
                  >
                    <Edit className="w-4 h-4 mr-1" />
                    Düzenle
                  </Button>
                  <Button
                    variant="outline"
                    onClick={() => {
                      handleDeleteReservation(selectedReservationDetail.id);
                      setShowReservationDetailModal(false);
                    }}
                    className="text-red-600 border-red-300 hover:bg-red-50"
                  >
                    <Trash2 className="w-4 h-4 mr-1" />
                    Sil
                  </Button>
                </div>
              </div>
            )}
          </DialogContent>
        </Dialog>

        {/* Havale Banka Hesabı Seçim Modalı */}
        <Dialog open={showResTransferModal} onOpenChange={setShowResTransferModal}>
          <DialogContent className="max-w-md" data-testid="res-transfer-modal">
            <DialogHeader>
              <DialogTitle className="flex items-center gap-2">
                <Landmark className="w-5 h-5 text-blue-600" /> Havale ile Ödendi → Bankaya Çek
              </DialogTitle>
              <DialogDescription>
                Tam maç tutarı seçilen banka hesabına gelir olarak yazılacak, hakem ücreti ayrı gider olarak takip edilecek ve rezervasyon hakemin bekleyen listesinden çıkacak.
              </DialogDescription>
            </DialogHeader>
            {selectedReservationDetail && (
              <div className="space-y-4">
                <Card className="bg-blue-50 border-blue-200">
                  <CardContent className="pt-4 space-y-1">
                    <div className="flex justify-between items-center">
                      <span className="text-xs text-blue-700 uppercase tracking-wide font-medium">Bankaya Geçecek Tutar</span>
                      <span className="text-2xl font-bold text-blue-900">₺{(selectedReservationDetail.total_amount || 0).toLocaleString()}</span>
                    </div>
                    {(selectedReservationDetail.referee_fee || 0) > 0 && (
                      <div className="flex justify-between items-center text-xs text-slate-600 pt-1 border-t border-blue-100">
                        <span>Hakem ücreti (ayrı gider olarak):</span>
                        <span className="font-semibold text-orange-700">-₺{(selectedReservationDetail.referee_fee || 0).toLocaleString()}</span>
                      </div>
                    )}
                  </CardContent>
                </Card>
                <div>
                  <Label className="mb-2 block">Hangi Banka Hesabına Geçti? *</Label>
                  <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
                    {[
                      { id: 'nakit', label: 'Nakit', icon: '💵' },
                      { id: 'garanti_bbva', label: 'Garanti BBVA', icon: '🏦' },
                      { id: 'bostanci', label: 'Bostancı', icon: '🏢' }
                    ].map(opt => (
                      <button
                        key={opt.id}
                        type="button"
                        onClick={() => setResTransferMethod(opt.id)}
                        className={`p-3 rounded-lg border-2 text-sm font-medium transition-all ${
                          resTransferMethod === opt.id
                            ? 'border-blue-500 bg-blue-50 text-blue-700 shadow-sm'
                            : 'border-slate-200 bg-white text-slate-600 hover:border-slate-300'
                        }`}
                        data-testid={`res-transfer-method-${opt.id}`}
                      >
                        <div className="text-xl mb-1">{opt.icon}</div>
                        <div>{opt.label}</div>
                      </button>
                    ))}
                  </div>
                </div>
                <div className="flex gap-2 pt-2">
                  <Button type="button" variant="outline" onClick={() => setShowResTransferModal(false)} className="flex-1">İptal</Button>
                  <Button onClick={confirmReservationTransfer} disabled={resTransferLoading} className="flex-1 bg-blue-600 hover:bg-blue-700" data-testid="confirm-res-transfer-btn">
                    <Landmark className="w-4 h-4 mr-1" /> {resTransferLoading ? 'İşleniyor...' : 'Bankaya İşle'}
                  </Button>
                </div>
              </div>
            )}
          </DialogContent>
        </Dialog>

        {/* Ödeme Yöntemi (Kasa Hesabı) Seçim Modalı — hakemsiz rezervasyon "Ödendi" */}
        <Dialog open={showPayMethodModal} onOpenChange={setShowPayMethodModal}>
          <DialogContent className="max-w-md" data-testid="pay-method-modal">
            <DialogHeader>
              <DialogTitle className="flex items-center gap-2">
                <PiggyBank className="w-5 h-5 text-emerald-600" /> Tahsilat — Hangi Hesaba?
              </DialogTitle>
              <DialogDescription>
                Bu rezervasyonun ödemesi tahsil edildi olarak işaretlenecek ve tutar seçtiğiniz kasa hesabına gelir olarak yazılacak.
              </DialogDescription>
            </DialogHeader>
            {payMethodTarget && (
              <div className="space-y-4">
                <Card className="bg-emerald-50 border-emerald-200">
                  <CardContent className="pt-4">
                    <div className="flex justify-between items-center">
                      <span className="text-xs text-emerald-700 uppercase tracking-wide font-medium">Tahsil Edilecek Tutar</span>
                      <span className="text-2xl font-bold text-emerald-900">₺{(payMethodTarget.total_amount || 0).toLocaleString()}</span>
                    </div>
                    {(payMethodTarget.paid_amount || 0) > 0 && (
                      <div className="flex justify-between items-center text-xs text-slate-600 pt-1 border-t border-emerald-100 mt-1">
                        <span>Önceden alınan kapora:</span>
                        <span className="font-semibold">₺{(payMethodTarget.paid_amount || 0).toLocaleString()}</span>
                      </div>
                    )}
                  </CardContent>
                </Card>
                <div>
                  <Label className="mb-2 block">Hangi Kasa Hesabına? *</Label>
                  <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
                    {[
                      { id: 'nakit', label: 'Nakit', icon: '💵' },
                      { id: 'garanti_bbva', label: 'Garanti BBVA', icon: '🏦' },
                      { id: 'bostanci', label: 'Bostancı', icon: '🏢' }
                    ].map(opt => (
                      <button
                        key={opt.id}
                        type="button"
                        onClick={() => setPayMethodChoice(opt.id)}
                        className={`p-3 rounded-lg border-2 text-sm font-medium transition-all ${
                          payMethodChoice === opt.id
                            ? 'border-emerald-500 bg-emerald-50 text-emerald-700 shadow-sm'
                            : 'border-slate-200 bg-white text-slate-600 hover:border-slate-300'
                        }`}
                        data-testid={`pay-method-${opt.id}`}
                      >
                        <div className="text-xl mb-1">{opt.icon}</div>
                        <div>{opt.label}</div>
                      </button>
                    ))}
                  </div>
                </div>
                <div className="flex gap-2 pt-2">
                  <Button type="button" variant="outline" onClick={() => setShowPayMethodModal(false)} className="flex-1">İptal</Button>
                  <Button onClick={confirmPayMethod} disabled={payMethodLoading} className="flex-1 bg-emerald-600 hover:bg-emerald-700" data-testid="confirm-pay-method-btn">
                    <CheckCircle2 className="w-4 h-4 mr-1" /> {payMethodLoading ? 'İşleniyor...' : 'Tahsil Et'}
                  </Button>
                </div>
              </div>
            )}
          </DialogContent>
        </Dialog>

        {/* Edit Match Modal */}
        <Dialog open={showEditMatchModal} onOpenChange={setShowEditMatchModal}>
          <DialogContent className="max-w-md">
            <DialogHeader>
              <DialogTitle>Maç Düzenle</DialogTitle>
              <DialogDescription>Maç bilgilerini güncelleyin</DialogDescription>
            </DialogHeader>
            {editingMatch && (
              <form onSubmit={handleUpdateMatch} className="space-y-4">
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <Label>Tarih</Label>
                    <Input
                      type="date"
                      value={editingMatch.date}
                      onChange={(e) => setEditingMatch({...editingMatch, date: e.target.value})}
                      required
                    />
                  </div>
                  <div>
                    <Label>Saat</Label>
                    <Input
                      type="time"
                      value={editingMatch.time?.slice(0, 5)}
                      onChange={(e) => setEditingMatch({...editingMatch, time: e.target.value})}
                      required
                    />
                  </div>
                </div>
                <div>
                  <Label>Hafta</Label>
                  <Input
                    type="number"
                    value={editingMatch.week}
                    onChange={(e) => setEditingMatch({...editingMatch, week: parseInt(e.target.value)})}
                    required
                  />
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <Label>Ev Sahibi Ödeme (₺)</Label>
                    <Input
                      type="number"
                      step="0.01"
                      value={editingMatch.home_team_payment_amount || 0}
                      onChange={(e) => setEditingMatch({...editingMatch, home_team_payment_amount: parseFloat(e.target.value)})}
                    />
                  </div>
                  <div>
                    <Label>Deplasman Ödeme (₺)</Label>
                    <Input
                      type="number"
                      step="0.01"
                      value={editingMatch.away_team_payment_amount || 0}
                      onChange={(e) => setEditingMatch({...editingMatch, away_team_payment_amount: parseFloat(e.target.value)})}
                    />
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <Label>Saha Kirası (₺)</Label>
                    <Input
                      type="number"
                      step="0.01"
                      value={editingMatch.field_rent || 0}
                      onChange={(e) => setEditingMatch({...editingMatch, field_rent: parseFloat(e.target.value)})}
                    />
                  </div>
                  <div>
                    <Label>Diğer Giderler (₺)</Label>
                    <Input
                      type="number"
                      step="0.01"
                      value={editingMatch.other_expenses || 0}
                      onChange={(e) => setEditingMatch({...editingMatch, other_expenses: parseFloat(e.target.value)})}
                    />
                  </div>
                </div>
                <div>
                  <Label>Notlar</Label>
                  <Textarea
                    value={editingMatch.notes || ''}
                    onChange={(e) => setEditingMatch({...editingMatch, notes: e.target.value})}
                  />
                </div>
                <Button type="submit" className="w-full bg-blue-600 hover:bg-blue-700">
                  Güncelle
                </Button>
              </form>
            )}
          </DialogContent>
        </Dialog>

        {/* Personnel Detail Modal */}
        <Dialog open={showPersonnelDetailModal} onOpenChange={setShowPersonnelDetailModal}>
          <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
            <DialogHeader>
              <DialogTitle className="flex items-center gap-2">
                <Users className="w-5 h-5 text-blue-600" />
                Personel Muhasebe - {selectedPersonnel?.name}
              </DialogTitle>
              <DialogDescription>Maaş, avans ve diğer ödemeleri yönetin</DialogDescription>
            </DialogHeader>
            {selectedPersonnel && personnelSummary && (
              <div className="space-y-6">
                {/* Personel Bilgileri */}
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                  <Card className="bg-blue-50">
                    <CardContent className="pt-4 text-center">
                      <p className="text-xs text-blue-600 mb-1">Pozisyon</p>
                      <p className="font-semibold text-blue-900">{selectedPersonnel.position || '-'}</p>
                    </CardContent>
                  </Card>
                  <Card className="bg-green-50">
                    <CardContent className="pt-4 text-center">
                      <p className="text-xs text-green-600 mb-1">Aylık Maaş</p>
                      <p className="font-bold text-green-900">₺{(selectedPersonnel.salary || 0).toLocaleString()}</p>
                    </CardContent>
                  </Card>
                  <Card className="bg-purple-50">
                    <CardContent className="pt-4 text-center">
                      <p className="text-xs text-purple-600 mb-1">Toplam Ödenen</p>
                      <p className="font-bold text-purple-900">₺{(personnelSummary.total_paid || 0).toLocaleString()}</p>
                    </CardContent>
                  </Card>
                  <Card className="bg-orange-50">
                    <CardContent className="pt-4 text-center">
                      <p className="text-xs text-orange-600 mb-1">Ödeme Sayısı</p>
                      <p className="font-bold text-orange-900">{personnelSummary.payment_count || 0}</p>
                    </CardContent>
                  </Card>
                </div>

                {/* Ödeme Özeti */}
                <Card className="bg-slate-50">
                  <CardContent className="pt-4">
                    <p className="text-sm font-medium text-slate-700 mb-3">Ödeme Dağılımı</p>
                    <div className="grid grid-cols-4 gap-4 text-center text-sm">
                      <div>
                        <p className="text-slate-500">Maaş</p>
                        <p className="font-semibold text-green-600">₺{(personnelSummary.total_salary || 0).toLocaleString()}</p>
                      </div>
                      <div>
                        <p className="text-slate-500">Avans</p>
                        <p className="font-semibold text-orange-600">₺{(personnelSummary.total_advance || 0).toLocaleString()}</p>
                      </div>
                      <div>
                        <p className="text-slate-500">Prim</p>
                        <p className="font-semibold text-blue-600">₺{(personnelSummary.total_bonus || 0).toLocaleString()}</p>
                      </div>
                      <div>
                        <p className="text-slate-500">Diğer</p>
                        <p className="font-semibold text-purple-600">₺{(personnelSummary.total_other || 0).toLocaleString()}</p>
                      </div>
                    </div>
                  </CardContent>
                </Card>

                {/* Yeni Ödeme Formu */}
                <Card className="border-2 border-green-200">
                  <CardHeader className="bg-green-50 pb-2">
                    <CardTitle className="text-base flex items-center gap-2">
                      <DollarSign className="w-4 h-4 text-green-600" />
                      Yeni Ödeme Ekle
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="pt-4">
                    <form onSubmit={createPersonnelPayment} className="space-y-4">
                      <div className="grid grid-cols-2 gap-4">
                        <div>
                          <Label>Ödeme Türü *</Label>
                          <Select 
                            value={newPersonnelPayment.payment_type} 
                            onValueChange={(v) => setNewPersonnelPayment({...newPersonnelPayment, payment_type: v})}
                          >
                            <SelectTrigger>
                              <SelectValue />
                            </SelectTrigger>
                            <SelectContent>
                              <SelectItem value="maas">💰 Maaş</SelectItem>
                              <SelectItem value="avans">💵 Avans</SelectItem>
                              <SelectItem value="prim">🎁 Prim</SelectItem>
                              <SelectItem value="diger">📋 Diğer</SelectItem>
                            </SelectContent>
                          </Select>
                        </div>
                        <div>
                          <Label>Tutar (₺) *</Label>
                          <Input
                            type="number"
                            step="0.01"
                            value={newPersonnelPayment.amount}
                            onChange={(e) => setNewPersonnelPayment({...newPersonnelPayment, amount: e.target.value})}
                            placeholder="Örn: 15000"
                            required
                          />
                        </div>
                      </div>
                      <div className="grid grid-cols-2 gap-4">
                        <div>
                          <Label>Ödeme Tarihi</Label>
                          <Input
                            type="date"
                            value={newPersonnelPayment.date}
                            onChange={(e) => setNewPersonnelPayment({...newPersonnelPayment, date: e.target.value})}
                          />
                        </div>
                        <div>
                          <Label>Hangi Ay İçin</Label>
                          <Input
                            type="month"
                            value={newPersonnelPayment.month}
                            onChange={(e) => setNewPersonnelPayment({...newPersonnelPayment, month: e.target.value})}
                          />
                        </div>
                      </div>
                      <div>
                        <Label>Notlar</Label>
                        <Textarea
                          value={newPersonnelPayment.notes}
                          onChange={(e) => setNewPersonnelPayment({...newPersonnelPayment, notes: e.target.value})}
                          placeholder="Opsiyonel açıklama..."
                        />
                      </div>
                      <Button type="submit" className="w-full bg-green-600 hover:bg-green-700">
                        <DollarSign className="w-4 h-4 mr-2" />
                        Ödemeyi Kaydet (Kasadan Düşülecek)
                      </Button>
                    </form>
                  </CardContent>
                </Card>

                {/* Ödeme Geçmişi */}
                <Card>
                  <CardHeader className="pb-2">
                    <CardTitle className="text-base flex items-center gap-2">
                      <Receipt className="w-4 h-4 text-slate-600" />
                      Ödeme Geçmişi
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    {personnelPayments.length === 0 ? (
                      <div className="text-center py-8 text-slate-400">
                        <DollarSign className="w-12 h-12 mx-auto mb-2 opacity-50" />
                        <p>Henüz ödeme kaydı yok</p>
                      </div>
                    ) : (
                      <div className="space-y-2 max-h-[300px] overflow-y-auto">
                        {personnelPayments.map((payment) => (
                          <div 
                            key={payment.id} 
                            className={`flex items-center justify-between p-3 rounded-lg ${
                              payment.payment_type === 'maas' ? 'bg-green-50' :
                              payment.payment_type === 'avans' ? 'bg-orange-50' :
                              payment.payment_type === 'prim' ? 'bg-blue-50' : 'bg-purple-50'
                            }`}
                          >
                            <div>
                              <div className="flex items-center gap-2">
                                <Badge variant="outline" className="text-xs">
                                  {payment.payment_type === 'maas' ? '💰 Maaş' :
                                   payment.payment_type === 'avans' ? '💵 Avans' :
                                   payment.payment_type === 'prim' ? '🎁 Prim' : '📋 Diğer'}
                                </Badge>
                                <span className="text-xs text-slate-500">{payment.date}</span>
                                {payment.month && (
                                  <span className="text-xs text-slate-400">({payment.month})</span>
                                )}
                              </div>
                              {payment.notes && (
                                <p className="text-xs text-slate-600 mt-1">{payment.notes}</p>
                              )}
                            </div>
                            <div className="flex items-center gap-2">
                              <span className="font-bold text-red-600">-₺{payment.amount?.toLocaleString()}</span>
                              <Button
                                size="sm"
                                variant="ghost"
                                onClick={() => deletePersonnelPayment(payment.id)}
                                className="h-7 w-7 p-0 text-red-600 hover:bg-red-100"
                              >
                                <Trash2 className="w-3 h-3" />
                              </Button>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </CardContent>
                </Card>
              </div>
            )}
          </DialogContent>
        </Dialog>
      <Toaster position="top-right" />
    </AdminShell>
  );
}

export default App;